/*
 * Copyright (c) 2007 Ariel Flesler - https://github.com/flesler
 */
(function (f) {
    "use strict";
    "function" === typeof define && define.amd
        ? define(["jquery"], f)
        : "undefined" !== typeof module && module.exports
        ? (module.exports = f(require("jquery")))
        : f(jQuery);
})(function ($) {
    "use strict";
    function n(a) {
        return !a.nodeName || -1 !== $.inArray(a.nodeName.toLowerCase(), ["iframe", "#document", "html", "body"]);
    }
    function h(a) {
        return $.isFunction(a) || $.isPlainObject(a) ? a : { top: a, left: a };
    }
    var p = ($.scrollTo = function (a, d, b) {
        return $(window).scrollTo(a, d, b);
    });
    p.defaults = { axis: "xy", duration: 0, limit: !0 };
    $.fn.scrollTo = function (a, d, b) {
        "object" === typeof d && ((b = d), (d = 0));
        "function" === typeof b && (b = { onAfter: b });
        "max" === a && (a = 9e9);
        b = $.extend({}, p.defaults, b);
        d = d || b.duration;
        var u = b.queue && 1 < b.axis.length;
        u && (d /= 2);
        b.offset = h(b.offset);
        b.over = h(b.over);
        return this.each(function () {
            function k(a) {
                var k = $.extend({}, b, {
                    queue: !0,
                    duration: d,
                    complete:
                        a &&
                        function () {
                            a.call(q, e, b);
                        },
                });
                r.animate(f, k);
            }
            if (null !== a) {
                var l = n(this),
                    q = l ? this.contentWindow || window : this,
                    r = $(q),
                    e = a,
                    f = {},
                    t;
                switch (typeof e) {
                    case "number":
                    case "string":
                        if (/^([+-]=?)?\d+(\.\d+)?(px|%)?$/.test(e)) {
                            e = h(e);
                            break;
                        }
                        e = l ? $(e) : $(e, q);
                    case "object":
                        if (e.length === 0) return;
                        if (e.is || e.style) t = (e = $(e)).offset();
                }
                var v = ($.isFunction(b.offset) && b.offset(q, e)) || b.offset;
                $.each(b.axis.split(""), function (a, c) {
                    var d = "x" === c ? "Left" : "Top",
                        m = d.toLowerCase(),
                        g = "scroll" + d,
                        h = r[g](),
                        n = p.max(q, c);
                    t
                        ? ((f[g] = t[m] + (l ? 0 : h - r.offset()[m])),
                          b.margin && ((f[g] -= parseInt(e.css("margin" + d), 10) || 0), (f[g] -= parseInt(e.css("border" + d + "Width"), 10) || 0)),
                          (f[g] += v[m] || 0),
                          b.over[m] && (f[g] += e["x" === c ? "width" : "height"]() * b.over[m]))
                        : ((d = e[m]), (f[g] = d.slice && "%" === d.slice(-1) ? (parseFloat(d) / 100) * n : d));
                    b.limit && /^\d+$/.test(f[g]) && (f[g] = 0 >= f[g] ? 0 : Math.min(f[g], n));
                    !a && 1 < b.axis.length && (h === f[g] ? (f = {}) : u && (k(b.onAfterFirst), (f = {})));
                });
                k(b.onAfter);
            }
        });
    };
    p.max = function (a, d) {
        var b = "x" === d ? "Width" : "Height",
            h = "scroll" + b;
        if (!n(a)) return a[h] - $(a)[b.toLowerCase()]();
        var b = "client" + b,
            k = a.ownerDocument || a.document,
            l = k.documentElement,
            k = k.body;
        return Math.max(l[h], k[h]) - Math.min(l[b], k[b]);
    };
    $.Tween.propHooks.scrollLeft = $.Tween.propHooks.scrollTop = {
        get: function (a) {
            return $(a.elem)[a.prop]();
        },
        set: function (a) {
            var d = this.get(a);
            if (a.options.interrupt && a._last && a._last !== d) return $(a.elem).stop();
            var b = Math.round(a.now);
            d !== b && ($(a.elem)[a.prop](b), (a._last = this.get(a)));
        },
    };
    return p;
});

/* slick-carousel@1.8.1 */
!(function (i) {
    "use strict";
    "function" == typeof define && define.amd ? define(["jquery"], i) : "undefined" != typeof exports ? (module.exports = i(require("jquery"))) : i(jQuery);
})(function (i) {
    "use strict";
    var e = window.Slick || {};
    ((e = (function () {
        var e = 0;
        return function (t, o) {
            var s,
                n = this;
            (n.defaults = {
                accessibility: !0,
                adaptiveHeight: !1,
                appendArrows: i(t),
                appendDots: i(t),
                arrows: !0,
                asNavFor: null,
                prevArrow: '<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',
                nextArrow: '<button class="slick-next" aria-label="Next" type="button">Next</button>',
                autoplay: !1,
                autoplaySpeed: 3e3,
                centerMode: !1,
                centerPadding: "50px",
                cssEase: "ease",
                customPaging: function (e, t) {
                    return i('<button type="button" />').text(t + 1);
                },
                dots: !1,
                dotsClass: "slick-dots",
                draggable: !0,
                easing: "linear",
                edgeFriction: 0.35,
                fade: !1,
                focusOnSelect: !1,
                focusOnChange: !1,
                infinite: !0,
                initialSlide: 0,
                lazyLoad: "ondemand",
                mobileFirst: !1,
                pauseOnHover: !0,
                pauseOnFocus: !0,
                pauseOnDotsHover: !1,
                respondTo: "window",
                responsive: null,
                rows: 1,
                rtl: !1,
                slide: "",
                slidesPerRow: 1,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 500,
                swipe: !0,
                swipeToSlide: !1,
                touchMove: !0,
                touchThreshold: 5,
                useCSS: !0,
                useTransform: !0,
                variableWidth: !1,
                vertical: !1,
                verticalSwiping: !1,
                waitForAnimate: !0,
                zIndex: 1e3,
            }),
                (n.initials = {
                    animating: !1,
                    dragging: !1,
                    autoPlayTimer: null,
                    currentDirection: 0,
                    currentLeft: null,
                    currentSlide: 0,
                    direction: 1,
                    $dots: null,
                    listWidth: null,
                    listHeight: null,
                    loadIndex: 0,
                    $nextArrow: null,
                    $prevArrow: null,
                    scrolling: !1,
                    slideCount: null,
                    slideWidth: null,
                    $slideTrack: null,
                    $slides: null,
                    sliding: !1,
                    slideOffset: 0,
                    swipeLeft: null,
                    swiping: !1,
                    $list: null,
                    touchObject: {},
                    transformsEnabled: !1,
                    unslicked: !1,
                }),
                i.extend(n, n.initials),
                (n.activeBreakpoint = null),
                (n.animType = null),
                (n.animProp = null),
                (n.breakpoints = []),
                (n.breakpointSettings = []),
                (n.cssTransitions = !1),
                (n.focussed = !1),
                (n.interrupted = !1),
                (n.hidden = "hidden"),
                (n.paused = !0),
                (n.positionProp = null),
                (n.respondTo = null),
                (n.rowCount = 1),
                (n.shouldClick = !0),
                (n.$slider = i(t)),
                (n.$slidesCache = null),
                (n.transformType = null),
                (n.transitionType = null),
                (n.visibilityChange = "visibilitychange"),
                (n.windowWidth = 0),
                (n.windowTimer = null),
                (s = i(t).data("slick") || {}),
                (n.options = i.extend({}, n.defaults, o, s)),
                (n.currentSlide = n.options.initialSlide),
                (n.originalSettings = n.options),
                void 0 !== document.mozHidden
                    ? ((n.hidden = "mozHidden"), (n.visibilityChange = "mozvisibilitychange"))
                    : void 0 !== document.webkitHidden && ((n.hidden = "webkitHidden"), (n.visibilityChange = "webkitvisibilitychange")),
                (n.autoPlay = i.proxy(n.autoPlay, n)),
                (n.autoPlayClear = i.proxy(n.autoPlayClear, n)),
                (n.autoPlayIterator = i.proxy(n.autoPlayIterator, n)),
                (n.changeSlide = i.proxy(n.changeSlide, n)),
                (n.clickHandler = i.proxy(n.clickHandler, n)),
                (n.selectHandler = i.proxy(n.selectHandler, n)),
                (n.setPosition = i.proxy(n.setPosition, n)),
                (n.swipeHandler = i.proxy(n.swipeHandler, n)),
                (n.dragHandler = i.proxy(n.dragHandler, n)),
                (n.keyHandler = i.proxy(n.keyHandler, n)),
                (n.instanceUid = e++),
                (n.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/),
                n.registerBreakpoints(),
                n.init(!0);
        };
    })()).prototype.activateADA = function () {
        this.$slideTrack.find(".slick-active").attr({ "aria-hidden": "false" }).find("a, input, button, select").attr({ tabindex: "0" });
    }),
        (e.prototype.addSlide = e.prototype.slickAdd =
            function (e, t, o) {
                var s = this;
                if ("boolean" == typeof t) (o = t), (t = null);
                else if (t < 0 || t >= s.slideCount) return !1;
                s.unload(),
                    "number" == typeof t
                        ? 0 === t && 0 === s.$slides.length
                            ? i(e).appendTo(s.$slideTrack)
                            : o
                            ? i(e).insertBefore(s.$slides.eq(t))
                            : i(e).insertAfter(s.$slides.eq(t))
                        : !0 === o
                        ? i(e).prependTo(s.$slideTrack)
                        : i(e).appendTo(s.$slideTrack),
                    (s.$slides = s.$slideTrack.children(this.options.slide)),
                    s.$slideTrack.children(this.options.slide).detach(),
                    s.$slideTrack.append(s.$slides),
                    s.$slides.each(function (e, t) {
                        i(t).attr("data-slick-index", e);
                    }),
                    (s.$slidesCache = s.$slides),
                    s.reinit();
            }),
        (e.prototype.animateHeight = function () {
            var i = this;
            if (1 === i.options.slidesToShow && !0 === i.options.adaptiveHeight && !1 === i.options.vertical) {
                var e = i.$slides.eq(i.currentSlide).outerHeight(!0);
                i.$list.animate({ height: e }, i.options.speed);
            }
        }),
        (e.prototype.animateSlide = function (e, t) {
            var o = {},
                s = this;
            s.animateHeight(),
                !0 === s.options.rtl && !1 === s.options.vertical && (e = -e),
                !1 === s.transformsEnabled
                    ? !1 === s.options.vertical
                        ? s.$slideTrack.animate({ left: e }, s.options.speed, s.options.easing, t)
                        : s.$slideTrack.animate({ top: e }, s.options.speed, s.options.easing, t)
                    : !1 === s.cssTransitions
                    ? (!0 === s.options.rtl && (s.currentLeft = -s.currentLeft),
                      i({ animStart: s.currentLeft }).animate(
                          { animStart: e },
                          {
                              duration: s.options.speed,
                              easing: s.options.easing,
                              step: function (i) {
                                  (i = Math.ceil(i)),
                                      !1 === s.options.vertical
                                          ? ((o[s.animType] = "translate(" + i + "px, 0px)"), s.$slideTrack.css(o))
                                          : ((o[s.animType] = "translate(0px," + i + "px)"), s.$slideTrack.css(o));
                              },
                              complete: function () {
                                  t && t.call();
                              },
                          }
                      ))
                    : (s.applyTransition(),
                      (e = Math.ceil(e)),
                      !1 === s.options.vertical
                          ? (o[s.animType] = "translate3d(" + e + "px, 0px, 0px)")
                          : (o[s.animType] = "translate3d(0px," + e + "px, 0px)"),
                      s.$slideTrack.css(o),
                      t &&
                          setTimeout(function () {
                              s.disableTransition(), t.call();
                          }, s.options.speed));
        }),
        (e.prototype.getNavTarget = function () {
            var e = this,
                t = e.options.asNavFor;
            return t && null !== t && (t = i(t).not(e.$slider)), t;
        }),
        (e.prototype.asNavFor = function (e) {
            var t = this.getNavTarget();
            null !== t &&
                "object" == typeof t &&
                t.each(function () {
                    var t = i(this).slick("getSlick");
                    t.unslicked || t.slideHandler(e, !0);
                });
        }),
        (e.prototype.applyTransition = function (i) {
            var e = this,
                t = {};
            !1 === e.options.fade
                ? (t[e.transitionType] = e.transformType + " " + e.options.speed + "ms " + e.options.cssEase)
                : (t[e.transitionType] = "opacity " + e.options.speed + "ms " + e.options.cssEase),
                !1 === e.options.fade ? e.$slideTrack.css(t) : e.$slides.eq(i).css(t);
        }),
        (e.prototype.autoPlay = function () {
            var i = this;
            i.autoPlayClear(), i.slideCount > i.options.slidesToShow && (i.autoPlayTimer = setInterval(i.autoPlayIterator, i.options.autoplaySpeed));
        }),
        (e.prototype.autoPlayClear = function () {
            var i = this;
            i.autoPlayTimer && clearInterval(i.autoPlayTimer);
        }),
        (e.prototype.autoPlayIterator = function () {
            var i = this,
                e = i.currentSlide + i.options.slidesToScroll;
            i.paused ||
                i.interrupted ||
                i.focussed ||
                (!1 === i.options.infinite &&
                    (1 === i.direction && i.currentSlide + 1 === i.slideCount - 1
                        ? (i.direction = 0)
                        : 0 === i.direction && ((e = i.currentSlide - i.options.slidesToScroll), i.currentSlide - 1 == 0 && (i.direction = 1))),
                i.slideHandler(e));
        }),
        (e.prototype.buildArrows = function () {
            var e = this;
            !0 === e.options.arrows &&
                ((e.$prevArrow = i(e.options.prevArrow).addClass("slick-arrow")),
                (e.$nextArrow = i(e.options.nextArrow).addClass("slick-arrow")),
                e.slideCount > e.options.slidesToShow
                    ? (e.$prevArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),
                      e.$nextArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),
                      e.htmlExpr.test(e.options.prevArrow) && e.$prevArrow.prependTo(e.options.appendArrows),
                      e.htmlExpr.test(e.options.nextArrow) && e.$nextArrow.appendTo(e.options.appendArrows),
                      !0 !== e.options.infinite && e.$prevArrow.addClass("slick-disabled").attr("aria-disabled", "true"))
                    : e.$prevArrow.add(e.$nextArrow).addClass("slick-hidden").attr({ "aria-disabled": "true", tabindex: "-1" }));
        }),
        (e.prototype.buildDots = function () {
            var e,
                t,
                o = this;
            if (!0 === o.options.dots) {
                for (o.$slider.addClass("slick-dotted"), t = i("<ul />").addClass(o.options.dotsClass), e = 0; e <= o.getDotCount(); e += 1)
                    t.append(i("<li />").append(o.options.customPaging.call(this, o, e)));
                (o.$dots = t.appendTo(o.options.appendDots)), o.$dots.find("li").first().addClass("slick-active");
            }
        }),
        (e.prototype.buildOut = function () {
            var e = this;
            (e.$slides = e.$slider.children(e.options.slide + ":not(.slick-cloned)").addClass("slick-slide")),
                (e.slideCount = e.$slides.length),
                e.$slides.each(function (e, t) {
                    i(t)
                        .attr("data-slick-index", e)
                        .data("originalStyling", i(t).attr("style") || "");
                }),
                e.$slider.addClass("slick-slider"),
                (e.$slideTrack =
                    0 === e.slideCount ? i('<div class="slick-track"/>').appendTo(e.$slider) : e.$slides.wrapAll('<div class="slick-track"/>').parent()),
                (e.$list = e.$slideTrack.wrap('<div class="slick-list"/>').parent()),
                e.$slideTrack.css("opacity", 0),
                (!0 !== e.options.centerMode && !0 !== e.options.swipeToSlide) || (e.options.slidesToScroll = 1),
                i("img[data-lazy]", e.$slider).not("[src]").addClass("slick-loading"),
                e.setupInfinite(),
                e.buildArrows(),
                e.buildDots(),
                e.updateDots(),
                e.setSlideClasses("number" == typeof e.currentSlide ? e.currentSlide : 0),
                !0 === e.options.draggable && e.$list.addClass("draggable");
        }),
        (e.prototype.buildRows = function () {
            var i,
                e,
                t,
                o,
                s,
                n,
                r,
                l = this;
            if (((o = document.createDocumentFragment()), (n = l.$slider.children()), l.options.rows > 1)) {
                for (r = l.options.slidesPerRow * l.options.rows, s = Math.ceil(n.length / r), i = 0; i < s; i++) {
                    var d = document.createElement("div");
                    for (e = 0; e < l.options.rows; e++) {
                        var a = document.createElement("div");
                        for (t = 0; t < l.options.slidesPerRow; t++) {
                            var c = i * r + (e * l.options.slidesPerRow + t);
                            n.get(c) && a.appendChild(n.get(c));
                        }
                        d.appendChild(a);
                    }
                    o.appendChild(d);
                }
                l.$slider.empty().append(o),
                    l.$slider
                        .children()
                        .children()
                        .children()
                        .css({ width: 100 / l.options.slidesPerRow + "%", display: "inline-block" });
            }
        }),
        (e.prototype.checkResponsive = function (e, t) {
            var o,
                s,
                n,
                r = this,
                l = !1,
                d = r.$slider.width(),
                a = window.innerWidth || i(window).width();
            if (
                ("window" === r.respondTo ? (n = a) : "slider" === r.respondTo ? (n = d) : "min" === r.respondTo && (n = Math.min(a, d)),
                r.options.responsive && r.options.responsive.length && null !== r.options.responsive)
            ) {
                s = null;
                for (o in r.breakpoints)
                    r.breakpoints.hasOwnProperty(o) &&
                        (!1 === r.originalSettings.mobileFirst
                            ? n < r.breakpoints[o] && (s = r.breakpoints[o])
                            : n > r.breakpoints[o] && (s = r.breakpoints[o]));
                null !== s
                    ? null !== r.activeBreakpoint
                        ? (s !== r.activeBreakpoint || t) &&
                          ((r.activeBreakpoint = s),
                          "unslick" === r.breakpointSettings[s]
                              ? r.unslick(s)
                              : ((r.options = i.extend({}, r.originalSettings, r.breakpointSettings[s])),
                                !0 === e && (r.currentSlide = r.options.initialSlide),
                                r.refresh(e)),
                          (l = s))
                        : ((r.activeBreakpoint = s),
                          "unslick" === r.breakpointSettings[s]
                              ? r.unslick(s)
                              : ((r.options = i.extend({}, r.originalSettings, r.breakpointSettings[s])),
                                !0 === e && (r.currentSlide = r.options.initialSlide),
                                r.refresh(e)),
                          (l = s))
                    : null !== r.activeBreakpoint &&
                      ((r.activeBreakpoint = null),
                      (r.options = r.originalSettings),
                      !0 === e && (r.currentSlide = r.options.initialSlide),
                      r.refresh(e),
                      (l = s)),
                    e || !1 === l || r.$slider.trigger("breakpoint", [r, l]);
            }
        }),
        (e.prototype.changeSlide = function (e, t) {
            var o,
                s,
                n,
                r = this,
                l = i(e.currentTarget);
            switch (
                (l.is("a") && e.preventDefault(),
                l.is("li") || (l = l.closest("li")),
                (n = r.slideCount % r.options.slidesToScroll != 0),
                (o = n ? 0 : (r.slideCount - r.currentSlide) % r.options.slidesToScroll),
                e.data.message)
            ) {
                case "previous":
                    (s = 0 === o ? r.options.slidesToScroll : r.options.slidesToShow - o),
                        r.slideCount > r.options.slidesToShow && r.slideHandler(r.currentSlide - s, !1, t);
                    break;
                case "next":
                    (s = 0 === o ? r.options.slidesToScroll : o), r.slideCount > r.options.slidesToShow && r.slideHandler(r.currentSlide + s, !1, t);
                    break;
                case "index":
                    var d = 0 === e.data.index ? 0 : e.data.index || l.index() * r.options.slidesToScroll;
                    r.slideHandler(r.checkNavigable(d), !1, t), l.children().trigger("focus");
                    break;
                default:
                    return;
            }
        }),
        (e.prototype.checkNavigable = function (i) {
            var e, t;
            if (((e = this.getNavigableIndexes()), (t = 0), i > e[e.length - 1])) i = e[e.length - 1];
            else
                for (var o in e) {
                    if (i < e[o]) {
                        i = t;
                        break;
                    }
                    t = e[o];
                }
            return i;
        }),
        (e.prototype.cleanUpEvents = function () {
            var e = this;
            e.options.dots &&
                null !== e.$dots &&
                (i("li", e.$dots)
                    .off("click.slick", e.changeSlide)
                    .off("mouseenter.slick", i.proxy(e.interrupt, e, !0))
                    .off("mouseleave.slick", i.proxy(e.interrupt, e, !1)),
                !0 === e.options.accessibility && e.$dots.off("keydown.slick", e.keyHandler)),
                e.$slider.off("focus.slick blur.slick"),
                !0 === e.options.arrows &&
                    e.slideCount > e.options.slidesToShow &&
                    (e.$prevArrow && e.$prevArrow.off("click.slick", e.changeSlide),
                    e.$nextArrow && e.$nextArrow.off("click.slick", e.changeSlide),
                    !0 === e.options.accessibility &&
                        (e.$prevArrow && e.$prevArrow.off("keydown.slick", e.keyHandler), e.$nextArrow && e.$nextArrow.off("keydown.slick", e.keyHandler))),
                e.$list.off("touchstart.slick mousedown.slick", e.swipeHandler),
                e.$list.off("touchmove.slick mousemove.slick", e.swipeHandler),
                e.$list.off("touchend.slick mouseup.slick", e.swipeHandler),
                e.$list.off("touchcancel.slick mouseleave.slick", e.swipeHandler),
                e.$list.off("click.slick", e.clickHandler),
                i(document).off(e.visibilityChange, e.visibility),
                e.cleanUpSlideEvents(),
                !0 === e.options.accessibility && e.$list.off("keydown.slick", e.keyHandler),
                !0 === e.options.focusOnSelect && i(e.$slideTrack).children().off("click.slick", e.selectHandler),
                i(window).off("orientationchange.slick.slick-" + e.instanceUid, e.orientationChange),
                i(window).off("resize.slick.slick-" + e.instanceUid, e.resize),
                i("[draggable!=true]", e.$slideTrack).off("dragstart", e.preventDefault),
                i(window).off("load.slick.slick-" + e.instanceUid, e.setPosition);
        }),
        (e.prototype.cleanUpSlideEvents = function () {
            var e = this;
            e.$list.off("mouseenter.slick", i.proxy(e.interrupt, e, !0)), e.$list.off("mouseleave.slick", i.proxy(e.interrupt, e, !1));
        }),
        (e.prototype.cleanUpRows = function () {
            var i,
                e = this;
            e.options.rows > 1 && ((i = e.$slides.children().children()).removeAttr("style"), e.$slider.empty().append(i));
        }),
        (e.prototype.clickHandler = function (i) {
            !1 === this.shouldClick && (i.stopImmediatePropagation(), i.stopPropagation(), i.preventDefault());
        }),
        (e.prototype.destroy = function (e) {
            var t = this;
            t.autoPlayClear(),
                (t.touchObject = {}),
                t.cleanUpEvents(),
                i(".slick-cloned", t.$slider).detach(),
                t.$dots && t.$dots.remove(),
                t.$prevArrow &&
                    t.$prevArrow.length &&
                    (t.$prevArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display", ""),
                    t.htmlExpr.test(t.options.prevArrow) && t.$prevArrow.remove()),
                t.$nextArrow &&
                    t.$nextArrow.length &&
                    (t.$nextArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display", ""),
                    t.htmlExpr.test(t.options.nextArrow) && t.$nextArrow.remove()),
                t.$slides &&
                    (t.$slides
                        .removeClass("slick-slide slick-active slick-center slick-visible slick-current")
                        .removeAttr("aria-hidden")
                        .removeAttr("data-slick-index")
                        .each(function () {
                            i(this).attr("style", i(this).data("originalStyling"));
                        }),
                    t.$slideTrack.children(this.options.slide).detach(),
                    t.$slideTrack.detach(),
                    t.$list.detach(),
                    t.$slider.append(t.$slides)),
                t.cleanUpRows(),
                t.$slider.removeClass("slick-slider"),
                t.$slider.removeClass("slick-initialized"),
                t.$slider.removeClass("slick-dotted"),
                (t.unslicked = !0),
                e || t.$slider.trigger("destroy", [t]);
        }),
        (e.prototype.disableTransition = function (i) {
            var e = this,
                t = {};
            (t[e.transitionType] = ""), !1 === e.options.fade ? e.$slideTrack.css(t) : e.$slides.eq(i).css(t);
        }),
        (e.prototype.fadeSlide = function (i, e) {
            var t = this;
            !1 === t.cssTransitions
                ? (t.$slides.eq(i).css({ zIndex: t.options.zIndex }), t.$slides.eq(i).animate({ opacity: 1 }, t.options.speed, t.options.easing, e))
                : (t.applyTransition(i),
                  t.$slides.eq(i).css({ opacity: 1, zIndex: t.options.zIndex }),
                  e &&
                      setTimeout(function () {
                          t.disableTransition(i), e.call();
                      }, t.options.speed));
        }),
        (e.prototype.fadeSlideOut = function (i) {
            var e = this;
            !1 === e.cssTransitions
                ? e.$slides.eq(i).animate({ opacity: 0, zIndex: e.options.zIndex - 2 }, e.options.speed, e.options.easing)
                : (e.applyTransition(i), e.$slides.eq(i).css({ opacity: 0, zIndex: e.options.zIndex - 2 }));
        }),
        (e.prototype.filterSlides = e.prototype.slickFilter =
            function (i) {
                var e = this;
                null !== i &&
                    ((e.$slidesCache = e.$slides),
                    e.unload(),
                    e.$slideTrack.children(this.options.slide).detach(),
                    e.$slidesCache.filter(i).appendTo(e.$slideTrack),
                    e.reinit());
            }),
        (e.prototype.focusHandler = function () {
            var e = this;
            e.$slider.off("focus.slick blur.slick").on("focus.slick blur.slick", "*", function (t) {
                t.stopImmediatePropagation();
                var o = i(this);
                setTimeout(function () {
                    e.options.pauseOnFocus && ((e.focussed = o.is(":focus")), e.autoPlay());
                }, 0);
            });
        }),
        (e.prototype.getCurrent = e.prototype.slickCurrentSlide =
            function () {
                return this.currentSlide;
            }),
        (e.prototype.getDotCount = function () {
            var i = this,
                e = 0,
                t = 0,
                o = 0;
            if (!0 === i.options.infinite)
                if (i.slideCount <= i.options.slidesToShow) ++o;
                else
                    for (; e < i.slideCount; )
                        ++o,
                            (e = t + i.options.slidesToScroll),
                            (t += i.options.slidesToScroll <= i.options.slidesToShow ? i.options.slidesToScroll : i.options.slidesToShow);
            else if (!0 === i.options.centerMode) o = i.slideCount;
            else if (i.options.asNavFor)
                for (; e < i.slideCount; )
                    ++o,
                        (e = t + i.options.slidesToScroll),
                        (t += i.options.slidesToScroll <= i.options.slidesToShow ? i.options.slidesToScroll : i.options.slidesToShow);
            else o = 1 + Math.ceil((i.slideCount - i.options.slidesToShow) / i.options.slidesToScroll);
            return o - 1;
        }),
        (e.prototype.getLeft = function (i) {
            var e,
                t,
                o,
                s,
                n = this,
                r = 0;
            return (
                (n.slideOffset = 0),
                (t = n.$slides.first().outerHeight(!0)),
                !0 === n.options.infinite
                    ? (n.slideCount > n.options.slidesToShow &&
                          ((n.slideOffset = n.slideWidth * n.options.slidesToShow * -1),
                          (s = -1),
                          !0 === n.options.vertical &&
                              !0 === n.options.centerMode &&
                              (2 === n.options.slidesToShow ? (s = -1.5) : 1 === n.options.slidesToShow && (s = -2)),
                          (r = t * n.options.slidesToShow * s)),
                      n.slideCount % n.options.slidesToScroll != 0 &&
                          i + n.options.slidesToScroll > n.slideCount &&
                          n.slideCount > n.options.slidesToShow &&
                          (i > n.slideCount
                              ? ((n.slideOffset = (n.options.slidesToShow - (i - n.slideCount)) * n.slideWidth * -1),
                                (r = (n.options.slidesToShow - (i - n.slideCount)) * t * -1))
                              : ((n.slideOffset = (n.slideCount % n.options.slidesToScroll) * n.slideWidth * -1),
                                (r = (n.slideCount % n.options.slidesToScroll) * t * -1))))
                    : i + n.options.slidesToShow > n.slideCount &&
                      ((n.slideOffset = (i + n.options.slidesToShow - n.slideCount) * n.slideWidth), (r = (i + n.options.slidesToShow - n.slideCount) * t)),
                n.slideCount <= n.options.slidesToShow && ((n.slideOffset = 0), (r = 0)),
                !0 === n.options.centerMode && n.slideCount <= n.options.slidesToShow
                    ? (n.slideOffset = (n.slideWidth * Math.floor(n.options.slidesToShow)) / 2 - (n.slideWidth * n.slideCount) / 2)
                    : !0 === n.options.centerMode && !0 === n.options.infinite
                    ? (n.slideOffset += n.slideWidth * Math.floor(n.options.slidesToShow / 2) - n.slideWidth)
                    : !0 === n.options.centerMode && ((n.slideOffset = 0), (n.slideOffset += n.slideWidth * Math.floor(n.options.slidesToShow / 2))),
                (e = !1 === n.options.vertical ? i * n.slideWidth * -1 + n.slideOffset : i * t * -1 + r),
                !0 === n.options.variableWidth &&
                    ((o =
                        n.slideCount <= n.options.slidesToShow || !1 === n.options.infinite
                            ? n.$slideTrack.children(".slick-slide").eq(i)
                            : n.$slideTrack.children(".slick-slide").eq(i + n.options.slidesToShow)),
                    (e = !0 === n.options.rtl ? (o[0] ? -1 * (n.$slideTrack.width() - o[0].offsetLeft - o.width()) : 0) : o[0] ? -1 * o[0].offsetLeft : 0),
                    !0 === n.options.centerMode &&
                        ((o =
                            n.slideCount <= n.options.slidesToShow || !1 === n.options.infinite
                                ? n.$slideTrack.children(".slick-slide").eq(i)
                                : n.$slideTrack.children(".slick-slide").eq(i + n.options.slidesToShow + 1)),
                        (e = !0 === n.options.rtl ? (o[0] ? -1 * (n.$slideTrack.width() - o[0].offsetLeft - o.width()) : 0) : o[0] ? -1 * o[0].offsetLeft : 0),
                        (e += (n.$list.width() - o.outerWidth()) / 2))),
                e
            );
        }),
        (e.prototype.getOption = e.prototype.slickGetOption =
            function (i) {
                return this.options[i];
            }),
        (e.prototype.getNavigableIndexes = function () {
            var i,
                e = this,
                t = 0,
                o = 0,
                s = [];
            for (
                !1 === e.options.infinite
                    ? (i = e.slideCount)
                    : ((t = -1 * e.options.slidesToScroll), (o = -1 * e.options.slidesToScroll), (i = 2 * e.slideCount));
                t < i;

            )
                s.push(t),
                    (t = o + e.options.slidesToScroll),
                    (o += e.options.slidesToScroll <= e.options.slidesToShow ? e.options.slidesToScroll : e.options.slidesToShow);
            return s;
        }),
        (e.prototype.getSlick = function () {
            return this;
        }),
        (e.prototype.getSlideCount = function () {
            var e,
                t,
                o = this;
            return (
                (t = !0 === o.options.centerMode ? o.slideWidth * Math.floor(o.options.slidesToShow / 2) : 0),
                !0 === o.options.swipeToSlide
                    ? (o.$slideTrack.find(".slick-slide").each(function (s, n) {
                          if (n.offsetLeft - t + i(n).outerWidth() / 2 > -1 * o.swipeLeft) return (e = n), !1;
                      }),
                      Math.abs(i(e).attr("data-slick-index") - o.currentSlide) || 1)
                    : o.options.slidesToScroll
            );
        }),
        (e.prototype.goTo = e.prototype.slickGoTo =
            function (i, e) {
                this.changeSlide({ data: { message: "index", index: parseInt(i) } }, e);
            }),
        (e.prototype.init = function (e) {
            var t = this;
            i(t.$slider).hasClass("slick-initialized") ||
                (i(t.$slider).addClass("slick-initialized"),
                t.buildRows(),
                t.buildOut(),
                t.setProps(),
                t.startLoad(),
                t.loadSlider(),
                t.initializeEvents(),
                t.updateArrows(),
                t.updateDots(),
                t.checkResponsive(!0),
                t.focusHandler()),
                e && t.$slider.trigger("init", [t]),
                !0 === t.options.accessibility && t.initADA(),
                t.options.autoplay && ((t.paused = !1), t.autoPlay());
        }),
        (e.prototype.initADA = function () {
            var e = this,
                t = Math.ceil(e.slideCount / e.options.slidesToShow),
                o = e.getNavigableIndexes().filter(function (i) {
                    return i >= 0 && i < e.slideCount;
                });
            e.$slides
                .add(e.$slideTrack.find(".slick-cloned"))
                .attr({ "aria-hidden": "true", tabindex: "-1" })
                .find("a, input, button, select")
                .attr({ tabindex: "-1" }),
                null !== e.$dots &&
                    (e.$slides.not(e.$slideTrack.find(".slick-cloned")).each(function (t) {
                        var s = o.indexOf(t);
                        i(this).attr({ role: "tabpanel", id: "slick-slide" + e.instanceUid + t, tabindex: -1 }),
                            -1 !== s && i(this).attr({ "aria-describedby": "slick-slide-control" + e.instanceUid + s });
                    }),
                    e.$dots
                        .attr("role", "tablist")
                        .find("li")
                        .each(function (s) {
                            var n = o[s];
                            i(this).attr({ role: "presentation" }),
                                i(this)
                                    .find("button")
                                    .first()
                                    .attr({
                                        role: "tab",
                                        id: "slick-slide-control" + e.instanceUid + s,
                                        "aria-controls": "slick-slide" + e.instanceUid + n,
                                        "aria-label": s + 1 + " of " + t,
                                        "aria-selected": null,
                                        tabindex: "-1",
                                    });
                        })
                        .eq(e.currentSlide)
                        .find("button")
                        .attr({ "aria-selected": "true", tabindex: "0" })
                        .end());
            for (var s = e.currentSlide, n = s + e.options.slidesToShow; s < n; s++) e.$slides.eq(s).attr("tabindex", 0);
            e.activateADA();
        }),
        (e.prototype.initArrowEvents = function () {
            var i = this;
            !0 === i.options.arrows &&
                i.slideCount > i.options.slidesToShow &&
                (i.$prevArrow.off("click.slick").on("click.slick", { message: "previous" }, i.changeSlide),
                i.$nextArrow.off("click.slick").on("click.slick", { message: "next" }, i.changeSlide),
                !0 === i.options.accessibility && (i.$prevArrow.on("keydown.slick", i.keyHandler), i.$nextArrow.on("keydown.slick", i.keyHandler)));
        }),
        (e.prototype.initDotEvents = function () {
            var e = this;
            !0 === e.options.dots &&
                (i("li", e.$dots).on("click.slick", { message: "index" }, e.changeSlide),
                !0 === e.options.accessibility && e.$dots.on("keydown.slick", e.keyHandler)),
                !0 === e.options.dots &&
                    !0 === e.options.pauseOnDotsHover &&
                    i("li", e.$dots).on("mouseenter.slick", i.proxy(e.interrupt, e, !0)).on("mouseleave.slick", i.proxy(e.interrupt, e, !1));
        }),
        (e.prototype.initSlideEvents = function () {
            var e = this;
            e.options.pauseOnHover &&
                (e.$list.on("mouseenter.slick", i.proxy(e.interrupt, e, !0)), e.$list.on("mouseleave.slick", i.proxy(e.interrupt, e, !1)));
        }),
        (e.prototype.initializeEvents = function () {
            var e = this;
            e.initArrowEvents(),
                e.initDotEvents(),
                e.initSlideEvents(),
                e.$list.on("touchstart.slick mousedown.slick", { action: "start" }, e.swipeHandler),
                e.$list.on("touchmove.slick mousemove.slick", { action: "move" }, e.swipeHandler),
                e.$list.on("touchend.slick mouseup.slick", { action: "end" }, e.swipeHandler),
                e.$list.on("touchcancel.slick mouseleave.slick", { action: "end" }, e.swipeHandler),
                e.$list.on("click.slick", e.clickHandler),
                i(document).on(e.visibilityChange, i.proxy(e.visibility, e)),
                !0 === e.options.accessibility && e.$list.on("keydown.slick", e.keyHandler),
                !0 === e.options.focusOnSelect && i(e.$slideTrack).children().on("click.slick", e.selectHandler),
                i(window).on("orientationchange.slick.slick-" + e.instanceUid, i.proxy(e.orientationChange, e)),
                i(window).on("resize.slick.slick-" + e.instanceUid, i.proxy(e.resize, e)),
                i("[draggable!=true]", e.$slideTrack).on("dragstart", e.preventDefault),
                i(window).on("load.slick.slick-" + e.instanceUid, e.setPosition),
                i(e.setPosition);
        }),
        (e.prototype.initUI = function () {
            var i = this;
            !0 === i.options.arrows && i.slideCount > i.options.slidesToShow && (i.$prevArrow.show(), i.$nextArrow.show()),
                !0 === i.options.dots && i.slideCount > i.options.slidesToShow && i.$dots.show();
        }),
        (e.prototype.keyHandler = function (i) {
            var e = this;
            i.target.tagName.match("TEXTAREA|INPUT|SELECT") ||
                (37 === i.keyCode && !0 === e.options.accessibility
                    ? e.changeSlide({ data: { message: !0 === e.options.rtl ? "next" : "previous" } })
                    : 39 === i.keyCode && !0 === e.options.accessibility && e.changeSlide({ data: { message: !0 === e.options.rtl ? "previous" : "next" } }));
        }),
        (e.prototype.lazyLoad = function () {
            function e(e) {
                i("img[data-lazy]", e).each(function () {
                    var e = i(this),
                        t = i(this).attr("data-lazy"),
                        o = i(this).attr("data-srcset"),
                        s = i(this).attr("data-sizes") || n.$slider.attr("data-sizes"),
                        r = document.createElement("img");
                    (r.onload = function () {
                        e.animate({ opacity: 0 }, 100, function () {
                            o && (e.attr("srcset", o), s && e.attr("sizes", s)),
                                e.attr("src", t).animate({ opacity: 1 }, 200, function () {
                                    e.removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading");
                                }),
                                n.$slider.trigger("lazyLoaded", [n, e, t]);
                        });
                    }),
                        (r.onerror = function () {
                            e.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"),
                                n.$slider.trigger("lazyLoadError", [n, e, t]);
                        }),
                        (r.src = t);
                });
            }
            var t,
                o,
                s,
                n = this;
            if (
                (!0 === n.options.centerMode
                    ? !0 === n.options.infinite
                        ? (s = (o = n.currentSlide + (n.options.slidesToShow / 2 + 1)) + n.options.slidesToShow + 2)
                        : ((o = Math.max(0, n.currentSlide - (n.options.slidesToShow / 2 + 1))), (s = n.options.slidesToShow / 2 + 1 + 2 + n.currentSlide))
                    : ((o = n.options.infinite ? n.options.slidesToShow + n.currentSlide : n.currentSlide),
                      (s = Math.ceil(o + n.options.slidesToShow)),
                      !0 === n.options.fade && (o > 0 && o--, s <= n.slideCount && s++)),
                (t = n.$slider.find(".slick-slide").slice(o, s)),
                "anticipated" === n.options.lazyLoad)
            )
                for (var r = o - 1, l = s, d = n.$slider.find(".slick-slide"), a = 0; a < n.options.slidesToScroll; a++)
                    r < 0 && (r = n.slideCount - 1), (t = (t = t.add(d.eq(r))).add(d.eq(l))), r--, l++;
            e(t),
                n.slideCount <= n.options.slidesToShow
                    ? e(n.$slider.find(".slick-slide"))
                    : n.currentSlide >= n.slideCount - n.options.slidesToShow
                    ? e(n.$slider.find(".slick-cloned").slice(0, n.options.slidesToShow))
                    : 0 === n.currentSlide && e(n.$slider.find(".slick-cloned").slice(-1 * n.options.slidesToShow));
        }),
        (e.prototype.loadSlider = function () {
            var i = this;
            i.setPosition(),
                i.$slideTrack.css({ opacity: 1 }),
                i.$slider.removeClass("slick-loading"),
                i.initUI(),
                "progressive" === i.options.lazyLoad && i.progressiveLazyLoad();
        }),
        (e.prototype.next = e.prototype.slickNext =
            function () {
                this.changeSlide({ data: { message: "next" } });
            }),
        (e.prototype.orientationChange = function () {
            var i = this;
            i.checkResponsive(), i.setPosition();
        }),
        (e.prototype.pause = e.prototype.slickPause =
            function () {
                var i = this;
                i.autoPlayClear(), (i.paused = !0);
            }),
        (e.prototype.play = e.prototype.slickPlay =
            function () {
                var i = this;
                i.autoPlay(), (i.options.autoplay = !0), (i.paused = !1), (i.focussed = !1), (i.interrupted = !1);
            }),
        (e.prototype.postSlide = function (e) {
            var t = this;
            t.unslicked ||
                (t.$slider.trigger("afterChange", [t, e]),
                (t.animating = !1),
                t.slideCount > t.options.slidesToShow && t.setPosition(),
                (t.swipeLeft = null),
                t.options.autoplay && t.autoPlay(),
                !0 === t.options.accessibility && (t.initADA(), t.options.focusOnChange && i(t.$slides.get(t.currentSlide)).attr("tabindex", 0).focus()));
        }),
        (e.prototype.prev = e.prototype.slickPrev =
            function () {
                this.changeSlide({ data: { message: "previous" } });
            }),
        (e.prototype.preventDefault = function (i) {
            i.preventDefault();
        }),
        (e.prototype.progressiveLazyLoad = function (e) {
            e = e || 1;
            var t,
                o,
                s,
                n,
                r,
                l = this,
                d = i("img[data-lazy]", l.$slider);
            d.length
                ? ((t = d.first()),
                  (o = t.attr("data-lazy")),
                  (s = t.attr("data-srcset")),
                  (n = t.attr("data-sizes") || l.$slider.attr("data-sizes")),
                  ((r = document.createElement("img")).onload = function () {
                      s && (t.attr("srcset", s), n && t.attr("sizes", n)),
                          t.attr("src", o).removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading"),
                          !0 === l.options.adaptiveHeight && l.setPosition(),
                          l.$slider.trigger("lazyLoaded", [l, t, o]),
                          l.progressiveLazyLoad();
                  }),
                  (r.onerror = function () {
                      e < 3
                          ? setTimeout(function () {
                                l.progressiveLazyLoad(e + 1);
                            }, 500)
                          : (t.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"),
                            l.$slider.trigger("lazyLoadError", [l, t, o]),
                            l.progressiveLazyLoad());
                  }),
                  (r.src = o))
                : l.$slider.trigger("allImagesLoaded", [l]);
        }),
        (e.prototype.refresh = function (e) {
            var t,
                o,
                s = this;
            (o = s.slideCount - s.options.slidesToShow),
                !s.options.infinite && s.currentSlide > o && (s.currentSlide = o),
                s.slideCount <= s.options.slidesToShow && (s.currentSlide = 0),
                (t = s.currentSlide),
                s.destroy(!0),
                i.extend(s, s.initials, { currentSlide: t }),
                s.init(),
                e || s.changeSlide({ data: { message: "index", index: t } }, !1);
        }),
        (e.prototype.registerBreakpoints = function () {
            var e,
                t,
                o,
                s = this,
                n = s.options.responsive || null;
            if ("array" === i.type(n) && n.length) {
                s.respondTo = s.options.respondTo || "window";
                for (e in n)
                    if (((o = s.breakpoints.length - 1), n.hasOwnProperty(e))) {
                        for (t = n[e].breakpoint; o >= 0; ) s.breakpoints[o] && s.breakpoints[o] === t && s.breakpoints.splice(o, 1), o--;
                        s.breakpoints.push(t), (s.breakpointSettings[t] = n[e].settings);
                    }
                s.breakpoints.sort(function (i, e) {
                    return s.options.mobileFirst ? i - e : e - i;
                });
            }
        }),
        (e.prototype.reinit = function () {
            var e = this;
            (e.$slides = e.$slideTrack.children(e.options.slide).addClass("slick-slide")),
                (e.slideCount = e.$slides.length),
                e.currentSlide >= e.slideCount && 0 !== e.currentSlide && (e.currentSlide = e.currentSlide - e.options.slidesToScroll),
                e.slideCount <= e.options.slidesToShow && (e.currentSlide = 0),
                e.registerBreakpoints(),
                e.setProps(),
                e.setupInfinite(),
                e.buildArrows(),
                e.updateArrows(),
                e.initArrowEvents(),
                e.buildDots(),
                e.updateDots(),
                e.initDotEvents(),
                e.cleanUpSlideEvents(),
                e.initSlideEvents(),
                e.checkResponsive(!1, !0),
                !0 === e.options.focusOnSelect && i(e.$slideTrack).children().on("click.slick", e.selectHandler),
                e.setSlideClasses("number" == typeof e.currentSlide ? e.currentSlide : 0),
                e.setPosition(),
                e.focusHandler(),
                (e.paused = !e.options.autoplay),
                e.autoPlay(),
                e.$slider.trigger("reInit", [e]);
        }),
        (e.prototype.resize = function () {
            var e = this;
            i(window).width() !== e.windowWidth &&
                (clearTimeout(e.windowDelay),
                (e.windowDelay = window.setTimeout(function () {
                    (e.windowWidth = i(window).width()), e.checkResponsive(), e.unslicked || e.setPosition();
                }, 50)));
        }),
        (e.prototype.removeSlide = e.prototype.slickRemove =
            function (i, e, t) {
                var o = this;
                if (
                    ((i = "boolean" == typeof i ? (!0 === (e = i) ? 0 : o.slideCount - 1) : !0 === e ? --i : i),
                    o.slideCount < 1 || i < 0 || i > o.slideCount - 1)
                )
                    return !1;
                o.unload(),
                    !0 === t ? o.$slideTrack.children().remove() : o.$slideTrack.children(this.options.slide).eq(i).remove(),
                    (o.$slides = o.$slideTrack.children(this.options.slide)),
                    o.$slideTrack.children(this.options.slide).detach(),
                    o.$slideTrack.append(o.$slides),
                    (o.$slidesCache = o.$slides),
                    o.reinit();
            }),
        (e.prototype.setCSS = function (i) {
            var e,
                t,
                o = this,
                s = {};
            !0 === o.options.rtl && (i = -i),
                (e = "left" == o.positionProp ? Math.ceil(i) + "px" : "0px"),
                (t = "top" == o.positionProp ? Math.ceil(i) + "px" : "0px"),
                (s[o.positionProp] = i),
                !1 === o.transformsEnabled
                    ? o.$slideTrack.css(s)
                    : ((s = {}),
                      !1 === o.cssTransitions
                          ? ((s[o.animType] = "translate(" + e + ", " + t + ")"), o.$slideTrack.css(s))
                          : ((s[o.animType] = "translate3d(" + e + ", " + t + ", 0px)"), o.$slideTrack.css(s)));
        }),
        (e.prototype.setDimensions = function () {
            var i = this;
            !1 === i.options.vertical
                ? !0 === i.options.centerMode && i.$list.css({ padding: "0px " + i.options.centerPadding })
                : (i.$list.height(i.$slides.first().outerHeight(!0) * i.options.slidesToShow),
                  !0 === i.options.centerMode && i.$list.css({ padding: i.options.centerPadding + " 0px" })),
                (i.listWidth = i.$list.width()),
                (i.listHeight = i.$list.height()),
                !1 === i.options.vertical && !1 === i.options.variableWidth
                    ? ((i.slideWidth = Math.ceil(i.listWidth / i.options.slidesToShow)),
                      i.$slideTrack.width(Math.ceil(i.slideWidth * i.$slideTrack.children(".slick-slide").length)))
                    : !0 === i.options.variableWidth
                    ? i.$slideTrack.width(5e3 * i.slideCount)
                    : ((i.slideWidth = Math.ceil(i.listWidth)),
                      i.$slideTrack.height(Math.ceil(i.$slides.first().outerHeight(!0) * i.$slideTrack.children(".slick-slide").length)));
            var e = i.$slides.first().outerWidth(!0) - i.$slides.first().width();
            !1 === i.options.variableWidth && i.$slideTrack.children(".slick-slide").width(i.slideWidth - e);
        }),
        (e.prototype.setFade = function () {
            var e,
                t = this;
            t.$slides.each(function (o, s) {
                (e = t.slideWidth * o * -1),
                    !0 === t.options.rtl
                        ? i(s).css({ position: "relative", right: e, top: 0, zIndex: t.options.zIndex - 2, opacity: 0 })
                        : i(s).css({ position: "relative", left: e, top: 0, zIndex: t.options.zIndex - 2, opacity: 0 });
            }),
                t.$slides.eq(t.currentSlide).css({ zIndex: t.options.zIndex - 1, opacity: 1 });
        }),
        (e.prototype.setHeight = function () {
            var i = this;
            if (1 === i.options.slidesToShow && !0 === i.options.adaptiveHeight && !1 === i.options.vertical) {
                var e = i.$slides.eq(i.currentSlide).outerHeight(!0);
                i.$list.css("height", e);
            }
        }),
        (e.prototype.setOption = e.prototype.slickSetOption =
            function () {
                var e,
                    t,
                    o,
                    s,
                    n,
                    r = this,
                    l = !1;
                if (
                    ("object" === i.type(arguments[0])
                        ? ((o = arguments[0]), (l = arguments[1]), (n = "multiple"))
                        : "string" === i.type(arguments[0]) &&
                          ((o = arguments[0]),
                          (s = arguments[1]),
                          (l = arguments[2]),
                          "responsive" === arguments[0] && "array" === i.type(arguments[1]) ? (n = "responsive") : void 0 !== arguments[1] && (n = "single")),
                    "single" === n)
                )
                    r.options[o] = s;
                else if ("multiple" === n)
                    i.each(o, function (i, e) {
                        r.options[i] = e;
                    });
                else if ("responsive" === n)
                    for (t in s)
                        if ("array" !== i.type(r.options.responsive)) r.options.responsive = [s[t]];
                        else {
                            for (e = r.options.responsive.length - 1; e >= 0; )
                                r.options.responsive[e].breakpoint === s[t].breakpoint && r.options.responsive.splice(e, 1), e--;
                            r.options.responsive.push(s[t]);
                        }
                l && (r.unload(), r.reinit());
            }),
        (e.prototype.setPosition = function () {
            var i = this;
            i.setDimensions(), i.setHeight(), !1 === i.options.fade ? i.setCSS(i.getLeft(i.currentSlide)) : i.setFade(), i.$slider.trigger("setPosition", [i]);
        }),
        (e.prototype.setProps = function () {
            var i = this,
                e = document.body.style;
            (i.positionProp = !0 === i.options.vertical ? "top" : "left"),
                "top" === i.positionProp ? i.$slider.addClass("slick-vertical") : i.$slider.removeClass("slick-vertical"),
                (void 0 === e.WebkitTransition && void 0 === e.MozTransition && void 0 === e.msTransition) ||
                    (!0 === i.options.useCSS && (i.cssTransitions = !0)),
                i.options.fade &&
                    ("number" == typeof i.options.zIndex ? i.options.zIndex < 3 && (i.options.zIndex = 3) : (i.options.zIndex = i.defaults.zIndex)),
                void 0 !== e.OTransform &&
                    ((i.animType = "OTransform"),
                    (i.transformType = "-o-transform"),
                    (i.transitionType = "OTransition"),
                    void 0 === e.perspectiveProperty && void 0 === e.webkitPerspective && (i.animType = !1)),
                void 0 !== e.MozTransform &&
                    ((i.animType = "MozTransform"),
                    (i.transformType = "-moz-transform"),
                    (i.transitionType = "MozTransition"),
                    void 0 === e.perspectiveProperty && void 0 === e.MozPerspective && (i.animType = !1)),
                void 0 !== e.webkitTransform &&
                    ((i.animType = "webkitTransform"),
                    (i.transformType = "-webkit-transform"),
                    (i.transitionType = "webkitTransition"),
                    void 0 === e.perspectiveProperty && void 0 === e.webkitPerspective && (i.animType = !1)),
                void 0 !== e.msTransform &&
                    ((i.animType = "msTransform"),
                    (i.transformType = "-ms-transform"),
                    (i.transitionType = "msTransition"),
                    void 0 === e.msTransform && (i.animType = !1)),
                void 0 !== e.transform && !1 !== i.animType && ((i.animType = "transform"), (i.transformType = "transform"), (i.transitionType = "transition")),
                (i.transformsEnabled = i.options.useTransform && null !== i.animType && !1 !== i.animType);
        }),
        (e.prototype.setSlideClasses = function (i) {
            var e,
                t,
                o,
                s,
                n = this;
            if (
                ((t = n.$slider.find(".slick-slide").removeClass("slick-active slick-center slick-current").attr("aria-hidden", "true")),
                n.$slides.eq(i).addClass("slick-current"),
                !0 === n.options.centerMode)
            ) {
                var r = n.options.slidesToShow % 2 == 0 ? 1 : 0;
                (e = Math.floor(n.options.slidesToShow / 2)),
                    !0 === n.options.infinite &&
                        (i >= e && i <= n.slideCount - 1 - e
                            ? n.$slides
                                  .slice(i - e + r, i + e + 1)
                                  .addClass("slick-active")
                                  .attr("aria-hidden", "false")
                            : ((o = n.options.slidesToShow + i),
                              t
                                  .slice(o - e + 1 + r, o + e + 2)
                                  .addClass("slick-active")
                                  .attr("aria-hidden", "false")),
                        0 === i
                            ? t.eq(t.length - 1 - n.options.slidesToShow).addClass("slick-center")
                            : i === n.slideCount - 1 && t.eq(n.options.slidesToShow).addClass("slick-center")),
                    n.$slides.eq(i).addClass("slick-center");
            } else
                i >= 0 && i <= n.slideCount - n.options.slidesToShow
                    ? n.$slides
                          .slice(i, i + n.options.slidesToShow)
                          .addClass("slick-active")
                          .attr("aria-hidden", "false")
                    : t.length <= n.options.slidesToShow
                    ? t.addClass("slick-active").attr("aria-hidden", "false")
                    : ((s = n.slideCount % n.options.slidesToShow),
                      (o = !0 === n.options.infinite ? n.options.slidesToShow + i : i),
                      n.options.slidesToShow == n.options.slidesToScroll && n.slideCount - i < n.options.slidesToShow
                          ? t
                                .slice(o - (n.options.slidesToShow - s), o + s)
                                .addClass("slick-active")
                                .attr("aria-hidden", "false")
                          : t
                                .slice(o, o + n.options.slidesToShow)
                                .addClass("slick-active")
                                .attr("aria-hidden", "false"));
            ("ondemand" !== n.options.lazyLoad && "anticipated" !== n.options.lazyLoad) || n.lazyLoad();
        }),
        (e.prototype.setupInfinite = function () {
            var e,
                t,
                o,
                s = this;
            if (
                (!0 === s.options.fade && (s.options.centerMode = !1),
                !0 === s.options.infinite && !1 === s.options.fade && ((t = null), s.slideCount > s.options.slidesToShow))
            ) {
                for (o = !0 === s.options.centerMode ? s.options.slidesToShow + 1 : s.options.slidesToShow, e = s.slideCount; e > s.slideCount - o; e -= 1)
                    (t = e - 1),
                        i(s.$slides[t])
                            .clone(!0)
                            .attr("id", "")
                            .attr("data-slick-index", t - s.slideCount)
                            .prependTo(s.$slideTrack)
                            .addClass("slick-cloned");
                for (e = 0; e < o + s.slideCount; e += 1)
                    (t = e),
                        i(s.$slides[t])
                            .clone(!0)
                            .attr("id", "")
                            .attr("data-slick-index", t + s.slideCount)
                            .appendTo(s.$slideTrack)
                            .addClass("slick-cloned");
                s.$slideTrack
                    .find(".slick-cloned")
                    .find("[id]")
                    .each(function () {
                        i(this).attr("id", "");
                    });
            }
        }),
        (e.prototype.interrupt = function (i) {
            var e = this;
            i || e.autoPlay(), (e.interrupted = i);
        }),
        (e.prototype.selectHandler = function (e) {
            var t = this,
                o = i(e.target).is(".slick-slide") ? i(e.target) : i(e.target).parents(".slick-slide"),
                s = parseInt(o.attr("data-slick-index"));
            s || (s = 0), t.slideCount <= t.options.slidesToShow ? t.slideHandler(s, !1, !0) : t.slideHandler(s);
        }),
        (e.prototype.slideHandler = function (i, e, t) {
            var o,
                s,
                n,
                r,
                l,
                d = null,
                a = this;
            if (((e = e || !1), !((!0 === a.animating && !0 === a.options.waitForAnimate) || (!0 === a.options.fade && a.currentSlide === i))))
                if (
                    (!1 === e && a.asNavFor(i),
                    (o = i),
                    (d = a.getLeft(o)),
                    (r = a.getLeft(a.currentSlide)),
                    (a.currentLeft = null === a.swipeLeft ? r : a.swipeLeft),
                    !1 === a.options.infinite && !1 === a.options.centerMode && (i < 0 || i > a.getDotCount() * a.options.slidesToScroll))
                )
                    !1 === a.options.fade &&
                        ((o = a.currentSlide),
                        !0 !== t
                            ? a.animateSlide(r, function () {
                                  a.postSlide(o);
                              })
                            : a.postSlide(o));
                else if (!1 === a.options.infinite && !0 === a.options.centerMode && (i < 0 || i > a.slideCount - a.options.slidesToScroll))
                    !1 === a.options.fade &&
                        ((o = a.currentSlide),
                        !0 !== t
                            ? a.animateSlide(r, function () {
                                  a.postSlide(o);
                              })
                            : a.postSlide(o));
                else {
                    if (
                        (a.options.autoplay && clearInterval(a.autoPlayTimer),
                        (s =
                            o < 0
                                ? a.slideCount % a.options.slidesToScroll != 0
                                    ? a.slideCount - (a.slideCount % a.options.slidesToScroll)
                                    : a.slideCount + o
                                : o >= a.slideCount
                                ? a.slideCount % a.options.slidesToScroll != 0
                                    ? 0
                                    : o - a.slideCount
                                : o),
                        (a.animating = !0),
                        a.$slider.trigger("beforeChange", [a, a.currentSlide, s]),
                        (n = a.currentSlide),
                        (a.currentSlide = s),
                        a.setSlideClasses(a.currentSlide),
                        a.options.asNavFor &&
                            (l = (l = a.getNavTarget()).slick("getSlick")).slideCount <= l.options.slidesToShow &&
                            l.setSlideClasses(a.currentSlide),
                        a.updateDots(),
                        a.updateArrows(),
                        !0 === a.options.fade)
                    )
                        return (
                            !0 !== t
                                ? (a.fadeSlideOut(n),
                                  a.fadeSlide(s, function () {
                                      a.postSlide(s);
                                  }))
                                : a.postSlide(s),
                            void a.animateHeight()
                        );
                    !0 !== t
                        ? a.animateSlide(d, function () {
                              a.postSlide(s);
                          })
                        : a.postSlide(s);
                }
        }),
        (e.prototype.startLoad = function () {
            var i = this;
            !0 === i.options.arrows && i.slideCount > i.options.slidesToShow && (i.$prevArrow.hide(), i.$nextArrow.hide()),
                !0 === i.options.dots && i.slideCount > i.options.slidesToShow && i.$dots.hide(),
                i.$slider.addClass("slick-loading");
        }),
        (e.prototype.swipeDirection = function () {
            var i,
                e,
                t,
                o,
                s = this;
            return (
                (i = s.touchObject.startX - s.touchObject.curX),
                (e = s.touchObject.startY - s.touchObject.curY),
                (t = Math.atan2(e, i)),
                (o = Math.round((180 * t) / Math.PI)) < 0 && (o = 360 - Math.abs(o)),
                o <= 45 && o >= 0
                    ? !1 === s.options.rtl
                        ? "left"
                        : "right"
                    : o <= 360 && o >= 315
                    ? !1 === s.options.rtl
                        ? "left"
                        : "right"
                    : o >= 135 && o <= 225
                    ? !1 === s.options.rtl
                        ? "right"
                        : "left"
                    : !0 === s.options.verticalSwiping
                    ? o >= 35 && o <= 135
                        ? "down"
                        : "up"
                    : "vertical"
            );
        }),
        (e.prototype.swipeEnd = function (i) {
            var e,
                t,
                o = this;
            if (((o.dragging = !1), (o.swiping = !1), o.scrolling)) return (o.scrolling = !1), !1;
            if (((o.interrupted = !1), (o.shouldClick = !(o.touchObject.swipeLength > 10)), void 0 === o.touchObject.curX)) return !1;
            if ((!0 === o.touchObject.edgeHit && o.$slider.trigger("edge", [o, o.swipeDirection()]), o.touchObject.swipeLength >= o.touchObject.minSwipe)) {
                switch ((t = o.swipeDirection())) {
                    case "left":
                    case "down":
                        (e = o.options.swipeToSlide ? o.checkNavigable(o.currentSlide + o.getSlideCount()) : o.currentSlide + o.getSlideCount()),
                            (o.currentDirection = 0);
                        break;
                    case "right":
                    case "up":
                        (e = o.options.swipeToSlide ? o.checkNavigable(o.currentSlide - o.getSlideCount()) : o.currentSlide - o.getSlideCount()),
                            (o.currentDirection = 1);
                }
                "vertical" != t && (o.slideHandler(e), (o.touchObject = {}), o.$slider.trigger("swipe", [o, t]));
            } else o.touchObject.startX !== o.touchObject.curX && (o.slideHandler(o.currentSlide), (o.touchObject = {}));
        }),
        (e.prototype.swipeHandler = function (i) {
            var e = this;
            if (
                !(
                    !1 === e.options.swipe ||
                    ("ontouchend" in document && !1 === e.options.swipe) ||
                    (!1 === e.options.draggable && -1 !== i.type.indexOf("mouse"))
                )
            )
                switch (
                    ((e.touchObject.fingerCount = i.originalEvent && void 0 !== i.originalEvent.touches ? i.originalEvent.touches.length : 1),
                    (e.touchObject.minSwipe = e.listWidth / e.options.touchThreshold),
                    !0 === e.options.verticalSwiping && (e.touchObject.minSwipe = e.listHeight / e.options.touchThreshold),
                    i.data.action)
                ) {
                    case "start":
                        e.swipeStart(i);
                        break;
                    case "move":
                        e.swipeMove(i);
                        break;
                    case "end":
                        e.swipeEnd(i);
                }
        }),
        (e.prototype.swipeMove = function (i) {
            var e,
                t,
                o,
                s,
                n,
                r,
                l = this;
            return (
                (n = void 0 !== i.originalEvent ? i.originalEvent.touches : null),
                !(!l.dragging || l.scrolling || (n && 1 !== n.length)) &&
                    ((e = l.getLeft(l.currentSlide)),
                    (l.touchObject.curX = void 0 !== n ? n[0].pageX : i.clientX),
                    (l.touchObject.curY = void 0 !== n ? n[0].pageY : i.clientY),
                    (l.touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(l.touchObject.curX - l.touchObject.startX, 2)))),
                    (r = Math.round(Math.sqrt(Math.pow(l.touchObject.curY - l.touchObject.startY, 2)))),
                    !l.options.verticalSwiping && !l.swiping && r > 4
                        ? ((l.scrolling = !0), !1)
                        : (!0 === l.options.verticalSwiping && (l.touchObject.swipeLength = r),
                          (t = l.swipeDirection()),
                          void 0 !== i.originalEvent && l.touchObject.swipeLength > 4 && ((l.swiping = !0), i.preventDefault()),
                          (s = (!1 === l.options.rtl ? 1 : -1) * (l.touchObject.curX > l.touchObject.startX ? 1 : -1)),
                          !0 === l.options.verticalSwiping && (s = l.touchObject.curY > l.touchObject.startY ? 1 : -1),
                          (o = l.touchObject.swipeLength),
                          (l.touchObject.edgeHit = !1),
                          !1 === l.options.infinite &&
                              ((0 === l.currentSlide && "right" === t) || (l.currentSlide >= l.getDotCount() && "left" === t)) &&
                              ((o = l.touchObject.swipeLength * l.options.edgeFriction), (l.touchObject.edgeHit = !0)),
                          !1 === l.options.vertical ? (l.swipeLeft = e + o * s) : (l.swipeLeft = e + o * (l.$list.height() / l.listWidth) * s),
                          !0 === l.options.verticalSwiping && (l.swipeLeft = e + o * s),
                          !0 !== l.options.fade &&
                              !1 !== l.options.touchMove &&
                              (!0 === l.animating ? ((l.swipeLeft = null), !1) : void l.setCSS(l.swipeLeft))))
            );
        }),
        (e.prototype.swipeStart = function (i) {
            var e,
                t = this;
            if (((t.interrupted = !0), 1 !== t.touchObject.fingerCount || t.slideCount <= t.options.slidesToShow)) return (t.touchObject = {}), !1;
            void 0 !== i.originalEvent && void 0 !== i.originalEvent.touches && (e = i.originalEvent.touches[0]),
                (t.touchObject.startX = t.touchObject.curX = void 0 !== e ? e.pageX : i.clientX),
                (t.touchObject.startY = t.touchObject.curY = void 0 !== e ? e.pageY : i.clientY),
                (t.dragging = !0);
        }),
        (e.prototype.unfilterSlides = e.prototype.slickUnfilter =
            function () {
                var i = this;
                null !== i.$slidesCache &&
                    (i.unload(), i.$slideTrack.children(this.options.slide).detach(), i.$slidesCache.appendTo(i.$slideTrack), i.reinit());
            }),
        (e.prototype.unload = function () {
            var e = this;
            i(".slick-cloned", e.$slider).remove(),
                e.$dots && e.$dots.remove(),
                e.$prevArrow && e.htmlExpr.test(e.options.prevArrow) && e.$prevArrow.remove(),
                e.$nextArrow && e.htmlExpr.test(e.options.nextArrow) && e.$nextArrow.remove(),
                e.$slides.removeClass("slick-slide slick-active slick-visible slick-current").attr("aria-hidden", "true").css("width", "");
        }),
        (e.prototype.unslick = function (i) {
            var e = this;
            e.$slider.trigger("unslick", [e, i]), e.destroy();
        }),
        (e.prototype.updateArrows = function () {
            var i = this;
            Math.floor(i.options.slidesToShow / 2),
                !0 === i.options.arrows &&
                    i.slideCount > i.options.slidesToShow &&
                    !i.options.infinite &&
                    (i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false"),
                    i.$nextArrow.removeClass("slick-disabled").attr("aria-disabled", "false"),
                    0 === i.currentSlide
                        ? (i.$prevArrow.addClass("slick-disabled").attr("aria-disabled", "true"),
                          i.$nextArrow.removeClass("slick-disabled").attr("aria-disabled", "false"))
                        : i.currentSlide >= i.slideCount - i.options.slidesToShow && !1 === i.options.centerMode
                        ? (i.$nextArrow.addClass("slick-disabled").attr("aria-disabled", "true"),
                          i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false"))
                        : i.currentSlide >= i.slideCount - 1 &&
                          !0 === i.options.centerMode &&
                          (i.$nextArrow.addClass("slick-disabled").attr("aria-disabled", "true"),
                          i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false")));
        }),
        (e.prototype.updateDots = function () {
            var i = this;
            null !== i.$dots &&
                (i.$dots.find("li").removeClass("slick-active").end(),
                i.$dots
                    .find("li")
                    .eq(Math.floor(i.currentSlide / i.options.slidesToScroll))
                    .addClass("slick-active"));
        }),
        (e.prototype.visibility = function () {
            var i = this;
            i.options.autoplay && (document[i.hidden] ? (i.interrupted = !0) : (i.interrupted = !1));
        }),
        (i.fn.slick = function () {
            var i,
                t,
                o = this,
                s = arguments[0],
                n = Array.prototype.slice.call(arguments, 1),
                r = o.length;
            for (i = 0; i < r; i++)
                if (("object" == typeof s || void 0 === s ? (o[i].slick = new e(o[i], s)) : (t = o[i].slick[s].apply(o[i].slick, n)), void 0 !== t)) return t;
            return o;
        });
});
/*
 * Copyright 2013 Klaus Hartl https://github.com/carhartl/jquery-cookie
 */
(function (factory) {
    if (typeof define === "function" && define.amd) {
        define(["jquery"], factory);
    } else {
        if (typeof exports === "object") {
            factory(require("jquery"));
        } else {
            factory(jQuery);
        }
    }
})(function ($) {
    var pluses = /\+/g;
    function encode(s) {
        return config.raw ? s : encodeURIComponent(s);
    }
    function decode(s) {
        return config.raw ? s : decodeURIComponent(s);
    }
    function stringifyCookieValue(value) {
        return encode(config.json ? JSON.stringify(value) : String(value));
    }
    function parseCookieValue(s) {
        if (s.indexOf('"') === 0) {
            s = s.slice(1, -1).replace(/\\"/g, '"').replace(/\\\\/g, "\\");
        }
        try {
            s = decodeURIComponent(s.replace(pluses, " "));
            return config.json ? JSON.parse(s) : s;
        } catch (e) {}
    }
    function read(s, converter) {
        var value = config.raw ? s : parseCookieValue(s);
        return $.isFunction(converter) ? converter(value) : value;
    }
    var config = ($.cookie = function (key, value, options) {
        if (value !== undefined && !$.isFunction(value)) {
            options = $.extend({}, config.defaults, options);
            if (typeof options.expires === "number") {
                var days = options.expires,
                    t = (options.expires = new Date());
                t.setTime(+t + days * 86400000);
            }
            return (document.cookie = [
                encode(key),
                "=",
                stringifyCookieValue(value),
                options.expires ? "; expires=" + options.expires.toUTCString() : "",
                options.path ? "; path=" + options.path : "",
                options.domain ? "; domain=" + options.domain : "",
                options.secure ? "; secure" : "",
            ].join(""));
        }
        var result = key ? undefined : {};
        var cookies = document.cookie ? document.cookie.split("; ") : [];
        for (var i = 0, l = cookies.length; i < l; i++) {
            var parts = cookies[i].split("=");
            var name = decode(parts.shift());
            var cookie = parts.join("=");
            if (key && key === name) {
                result = read(cookie, value);
                break;
            }
            if (!key && (cookie = read(cookie)) !== undefined) {
                result[name] = cookie;
            }
        }
        return result;
    });
    config.defaults = {};
    $.removeCookie = function (key, options) {
        if ($.cookie(key) === undefined) {
            return false;
        }
        $.cookie(key, "", $.extend({}, options, { expires: -1 }));
        return !$.cookie(key);
    };
});
/*
 * @verlok - github.com/vanilla-lazyload
 */
!(function (t, n) {
    "object" == typeof exports && "undefined" != typeof module
        ? (module.exports = n())
        : "function" == typeof define && define.amd
        ? define(n)
        : ((t = "undefined" != typeof globalThis ? globalThis : t || self).LazyLoad = n());
})(this, function () {
    "use strict";
    function t() {
        return (t =
            Object.assign ||
            function (t) {
                for (var n = 1; n < arguments.length; n++) {
                    var e = arguments[n];
                    for (var i in e) Object.prototype.hasOwnProperty.call(e, i) && (t[i] = e[i]);
                }
                return t;
            }).apply(this, arguments);
    }
    var n = "undefined" != typeof window,
        e = (n && !("onscroll" in window)) || ("undefined" != typeof navigator && /(gle|ing|ro)bot|crawl|spider/i.test(navigator.userAgent)),
        i = n && "IntersectionObserver" in window,
        o = n && "classList" in document.createElement("p"),
        r = n && window.devicePixelRatio > 1,
        a = {
            elements_selector: ".lazy",
            container: e || n ? document : null,
            threshold: 300,
            thresholds: null,
            data_src: "src",
            data_srcset: "srcset",
            data_sizes: "sizes",
            data_bg: "bg",
            data_bg_hidpi: "bg-hidpi",
            data_bg_multi: "bg-multi",
            data_bg_multi_hidpi: "bg-multi-hidpi",
            data_poster: "poster",
            class_applied: "applied",
            class_loading: "loading",
            class_loaded: "loaded",
            class_error: "error",
            class_entered: "entered",
            class_exited: "exited",
            unobserve_completed: !0,
            unobserve_entered: !1,
            cancel_on_exit: !0,
            callback_enter: null,
            callback_exit: null,
            callback_applied: null,
            callback_loading: null,
            callback_loaded: null,
            callback_error: null,
            callback_finish: null,
            callback_cancel: null,
            use_native: !1,
        },
        c = function (n) {
            return t({}, a, n);
        },
        s = function (t, n) {
            var e,
                i = "LazyLoad::Initialized",
                o = new t(n);
            try {
                e = new CustomEvent(i, { detail: { instance: o } });
            } catch (t) {
                (e = document.createEvent("CustomEvent")).initCustomEvent(i, !1, !1, { instance: o });
            }
            window.dispatchEvent(e);
        },
        l = "loading",
        u = "loaded",
        d = "applied",
        f = "error",
        _ = "native",
        g = "data-",
        v = "ll-status",
        b = function (t, n) {
            return t.getAttribute(g + n);
        },
        p = function (t) {
            return b(t, v);
        },
        h = function (t, n) {
            return (function (t, n, e) {
                var i = "data-ll-status";
                null !== e ? t.setAttribute(i, e) : t.removeAttribute(i);
            })(t, 0, n);
        },
        m = function (t) {
            return h(t, null);
        },
        E = function (t) {
            return null === p(t);
        },
        y = function (t) {
            return p(t) === _;
        },
        I = [l, u, d, f],
        A = function (t, n, e, i) {
            t && (void 0 === i ? (void 0 === e ? t(n) : t(n, e)) : t(n, e, i));
        },
        L = function (t, n) {
            o ? t.classList.add(n) : (t.className += (t.className ? " " : "") + n);
        },
        w = function (t, n) {
            o
                ? t.classList.remove(n)
                : (t.className = t.className
                      .replace(new RegExp("(^|\\s+)" + n + "(\\s+|$)"), " ")
                      .replace(/^\s+/, "")
                      .replace(/\s+$/, ""));
        },
        k = function (t) {
            return t.llTempImage;
        },
        O = function (t, n) {
            if (n) {
                var e = n._observer;
                e && e.unobserve(t);
            }
        },
        x = function (t, n) {
            t && (t.loadingCount += n);
        },
        z = function (t, n) {
            t && (t.toLoadCount = n);
        },
        C = function (t) {
            for (var n, e = [], i = 0; (n = t.children[i]); i += 1) "SOURCE" === n.tagName && e.push(n);
            return e;
        },
        N = function (t, n, e) {
            e && t.setAttribute(n, e);
        },
        M = function (t, n) {
            t.removeAttribute(n);
        },
        R = function (t) {
            return !!t.llOriginalAttrs;
        },
        T = function (t) {
            if (!R(t)) {
                var n = {};
                (n.src = t.getAttribute("src")), (n.srcset = t.getAttribute("srcset")), (n.sizes = t.getAttribute("sizes")), (t.llOriginalAttrs = n);
            }
        },
        G = function (t) {
            if (R(t)) {
                var n = t.llOriginalAttrs;
                N(t, "src", n.src), N(t, "srcset", n.srcset), N(t, "sizes", n.sizes);
            }
        },
        D = function (t, n) {
            N(t, "sizes", b(t, n.data_sizes)), N(t, "srcset", b(t, n.data_srcset)), N(t, "src", b(t, n.data_src));
        },
        V = function (t) {
            M(t, "src"), M(t, "srcset"), M(t, "sizes");
        },
        j = function (t, n) {
            var e = t.parentNode;
            e && "PICTURE" === e.tagName && C(e).forEach(n);
        },
        F = {
            IMG: function (t, n) {
                j(t, function (t) {
                    T(t), D(t, n);
                }),
                    T(t),
                    D(t, n);
            },
            IFRAME: function (t, n) {
                N(t, "src", b(t, n.data_src));
            },
            VIDEO: function (t, n) {
                !(function (t, e) {
                    C(t).forEach(function (t) {
                        N(t, "src", b(t, n.data_src));
                    });
                })(t),
                    N(t, "poster", b(t, n.data_poster)),
                    N(t, "src", b(t, n.data_src)),
                    t.load();
            },
        },
        P = function (t, n) {
            var e = F[t.tagName];
            e && e(t, n);
        },
        S = function (t, n, e) {
            x(e, 1), L(t, n.class_loading), h(t, l), A(n.callback_loading, t, e);
        },
        U = ["IMG", "IFRAME", "VIDEO"],
        $ = function (t, n) {
            !n ||
                (function (t) {
                    return t.loadingCount > 0;
                })(n) ||
                (function (t) {
                    return t.toLoadCount > 0;
                })(n) ||
                A(t.callback_finish, n);
        },
        q = function (t, n, e) {
            t.addEventListener(n, e), (t.llEvLisnrs[n] = e);
        },
        H = function (t, n, e) {
            t.removeEventListener(n, e);
        },
        B = function (t) {
            return !!t.llEvLisnrs;
        },
        J = function (t) {
            if (B(t)) {
                var n = t.llEvLisnrs;
                for (var e in n) {
                    var i = n[e];
                    H(t, e, i);
                }
                delete t.llEvLisnrs;
            }
        },
        K = function (t, n, e) {
            !(function (t) {
                delete t.llTempImage;
            })(t),
                x(e, -1),
                (function (t) {
                    t && (t.toLoadCount -= 1);
                })(e),
                w(t, n.class_loading),
                n.unobserve_completed && O(t, e);
        },
        Q = function (t, n, e) {
            var i = k(t) || t;
            B(i) ||
                (function (t, n, e) {
                    B(t) || (t.llEvLisnrs = {});
                    var i = "VIDEO" === t.tagName ? "loadeddata" : "load";
                    q(t, i, n), q(t, "error", e);
                })(
                    i,
                    function (o) {
                        !(function (t, n, e, i) {
                            var o = y(n);
                            K(n, e, i), L(n, e.class_loaded), h(n, u), A(e.callback_loaded, n, i), o || $(e, i);
                        })(0, t, n, e),
                            J(i);
                    },
                    function (o) {
                        !(function (t, n, e, i) {
                            var o = y(n);
                            K(n, e, i), L(n, e.class_error), h(n, f), A(e.callback_error, n, i), o || $(e, i);
                        })(0, t, n, e),
                            J(i);
                    }
                );
        },
        W = function (t, n, e) {
            !(function (t) {
                t.llTempImage = document.createElement("IMG");
            })(t),
                Q(t, n, e),
                (function (t, n, e) {
                    var i = b(t, n.data_bg),
                        o = b(t, n.data_bg_hidpi),
                        a = r && o ? o : i;
                    a && ((t.style.backgroundImage = 'url("'.concat(a, '")')), k(t).setAttribute("src", a), S(t, n, e));
                })(t, n, e),
                (function (t, n, e) {
                    var i = b(t, n.data_bg_multi),
                        o = b(t, n.data_bg_multi_hidpi),
                        a = r && o ? o : i;
                    a &&
                        ((t.style.backgroundImage = a),
                        (function (t, n, e) {
                            L(t, n.class_applied), h(t, d), n.unobserve_completed && O(t, n), A(n.callback_applied, t, e);
                        })(t, n, e));
                })(t, n, e);
        },
        X = function (t, n, e) {
            !(function (t) {
                return U.indexOf(t.tagName) > -1;
            })(t)
                ? W(t, n, e)
                : (function (t, n, e) {
                      Q(t, n, e), P(t, n), S(t, n, e);
                  })(t, n, e);
        },
        Y = ["IMG", "IFRAME", "VIDEO"],
        Z = function (t) {
            return t.use_native && "loading" in HTMLImageElement.prototype;
        },
        tt = function (t, n, e) {
            t.forEach(function (t) {
                return (function (t) {
                    return t.isIntersecting || t.intersectionRatio > 0;
                })(t)
                    ? (function (t, n, e, i) {
                          var o = (function (t) {
                              return I.indexOf(p(t)) >= 0;
                          })(t);
                          h(t, "entered"),
                              L(t, e.class_entered),
                              w(t, e.class_exited),
                              (function (t, n, e) {
                                  n.unobserve_entered && O(t, e);
                              })(t, e, i),
                              A(e.callback_enter, t, n, i),
                              o || X(t, e, i);
                      })(t.target, t, n, e)
                    : (function (t, n, e, i) {
                          E(t) ||
                              (L(t, e.class_exited),
                              (function (t, n, e, i) {
                                  e.cancel_on_exit &&
                                      (function (t) {
                                          return p(t) === l;
                                      })(t) &&
                                      "IMG" === t.tagName &&
                                      (J(t),
                                      (function (t) {
                                          j(t, function (t) {
                                              V(t);
                                          }),
                                              V(t);
                                      })(t),
                                      (function (t) {
                                          j(t, function (t) {
                                              G(t);
                                          }),
                                              G(t);
                                      })(t),
                                      w(t, e.class_loading),
                                      x(i, -1),
                                      m(t),
                                      A(e.callback_cancel, t, n, i));
                              })(t, n, e, i),
                              A(e.callback_exit, t, n, i));
                      })(t.target, t, n, e);
            });
        },
        nt = function (t) {
            return Array.prototype.slice.call(t);
        },
        et = function (t) {
            return t.container.querySelectorAll(t.elements_selector);
        },
        it = function (t) {
            return (function (t) {
                return p(t) === f;
            })(t);
        },
        ot = function (t, n) {
            return (function (t) {
                return nt(t).filter(E);
            })(t || et(n));
        },
        rt = function (t, e) {
            var o = c(t);
            (this._settings = o),
                (this.loadingCount = 0),
                (function (t, n) {
                    i &&
                        !Z(t) &&
                        (n._observer = new IntersectionObserver(
                            function (e) {
                                tt(e, t, n);
                            },
                            (function (t) {
                                return { root: t.container === document ? null : t.container, rootMargin: t.thresholds || t.threshold + "px" };
                            })(t)
                        ));
                })(o, this),
                (function (t, e) {
                    n &&
                        window.addEventListener("online", function () {
                            !(function (t, n) {
                                var e;
                                ((e = et(t)), nt(e).filter(it)).forEach(function (n) {
                                    w(n, t.class_error), m(n);
                                }),
                                    n.update();
                            })(t, e);
                        });
                })(o, this),
                this.update(e);
        };
    return (
        (rt.prototype = {
            update: function (t) {
                var n,
                    o,
                    r = this._settings,
                    a = ot(t, r);
                z(this, a.length),
                    !e && i
                        ? Z(r)
                            ? (function (t, n, e) {
                                  t.forEach(function (t) {
                                      -1 !== Y.indexOf(t.tagName) &&
                                          (function (t, n, e) {
                                              t.setAttribute("loading", "lazy"), Q(t, n, e), P(t, n), h(t, _);
                                          })(t, n, e);
                                  }),
                                      z(e, 0);
                              })(a, r, this)
                            : ((o = a),
                              (function (t) {
                                  t.disconnect();
                              })((n = this._observer)),
                              (function (t, n) {
                                  n.forEach(function (n) {
                                      t.observe(n);
                                  });
                              })(n, o))
                        : this.loadAll(a);
            },
            destroy: function () {
                this._observer && this._observer.disconnect(),
                    et(this._settings).forEach(function (t) {
                        delete t.llOriginalAttrs;
                    }),
                    delete this._observer,
                    delete this._settings,
                    delete this.loadingCount,
                    delete this.toLoadCount;
            },
            loadAll: function (t) {
                var n = this,
                    e = this._settings;
                ot(t, e).forEach(function (t) {
                    O(t, n), X(t, e, n);
                });
            },
        }),
        (rt.load = function (t, n) {
            var e = c(n);
            X(t, e);
        }),
        (rt.resetStatus = function (t) {
            m(t);
        }),
        n &&
            (function (t, n) {
                if (n)
                    if (n.length) for (var e, i = 0; (e = n[i]); i += 1) s(t, e);
                    else s(t, n);
            })(rt, window.lazyLoadOptions),
        rt
    );
});
/*
 * https://www.maxmind.com/en/geoip2-precision-country-service
 */
("use strict");
var geoip2 = (function () {
    var e = {};
    function t(e, t, n, r) {
        (this.successCallback = e), (this.errorCallback = t), (this.type = r);
    }
    (t.prototype.returnSuccess = function (e) {
        this.successCallback && "function" == typeof this.successCallback && this.successCallback(this.fillInObject(JSON.parse(e)));
    }),
        (t.prototype.returnError = function (e) {
            this.errorCallback && "function" == typeof this.errorCallback && (e || (e = { error: "Unknown error" }), this.errorCallback(e));
        });
    var n = {
        country: [
            ["continent", "Object", "names", "Object"],
            ["country", "Object", "names", "Object"],
            ["registered_country", "Object", "names", "Object"],
            ["represented_country", "Object", "names", "Object"],
            ["traits", "Object"],
        ],
        city: [
            ["city", "Object", "names", "Object"],
            ["continent", "Object", "names", "Object"],
            ["country", "Object", "names", "Object"],
            ["location", "Object"],
            ["postal", "Object"],
            ["registered_country", "Object", "names", "Object"],
            ["represented_country", "Object", "names", "Object"],
            ["subdivisions", "Array", 0, "Object", "names", "Object"],
            ["traits", "Object"],
        ],
    };
    return (
        (t.prototype.fillInObject = function (e) {
            for (var t = "country" === this.type ? n.country : n.city, r = 0; r < t.length; r++)
                for (var o = t[r], s = e, i = 0; i < o.length; i += 2) {
                    var c = o[i];
                    s[c] || (s[c] = "Object" === o[i + 1] ? {} : []), (s = s[c]);
                }
            try {
                Object.defineProperty(e.continent, "continent_code", {
                    enumerable: !1,
                    get: function () {
                        return this.code;
                    },
                    set: function (e) {
                        this.code = e;
                    },
                });
            } catch (t) {
                e.continent.code && (e.continent.continent_code = e.continent.code);
            }
            if ("country" !== this.type)
                try {
                    Object.defineProperty(e, "most_specific_subdivision", {
                        enumerable: !1,
                        get: function () {
                            return this.subdivisions[this.subdivisions.length - 1];
                        },
                        set: function (e) {
                            this.subdivisions[this.subdivisions.length - 1] = e;
                        },
                    });
                } catch (t) {
                    e.most_specific_subdivision = e.subdivisions[e.subdivisions.length - 1];
                }
            return e;
        }),
        (t.prototype.getGeoIPResult = function () {
            var e,
                t = window.location.hostname,
                n = t.split(".").reverse();
            "maxmind" !== n[1] || ("com" !== n[0] && "dev" !== n[0]) || "www.maxmind.com" === t || (e = t);
            var r,
                o = this,
                s = new window.XMLHttpRequest(),
                i = "https://" + (e || "geoip-js.com") + "/geoip/v2.1/" + this.type + "/me?",
                c = { referrer: location.protocol + "//" + location.hostname };
            if (!this.alreadyRan) {
                for (r in ((this.alreadyRan = 1), c)) c.hasOwnProperty(r) && c[r] && (i += r + "=" + encodeURIComponent(c[r]) + "&");
                (i = i.substring(0, i.length - 1)),
                    s.open("GET", i, !0),
                    (s.onload = function () {
                        if (void 0 === s.status || 200 === s.status) o.returnSuccess(s.responseText);
                        else {
                            var e,
                                t = s.hasOwnProperty("contentType") ? s.contentType : s.getResponseHeader("Content-Type");
                            if (/json/.test(t) && s.responseText.length)
                                try {
                                    e = JSON.parse(s.responseText);
                                } catch (t) {
                                    e = { code: "HTTP_ERROR", error: "The server returned a " + s.status + " status with an invalid JSON body." };
                                }
                            else
                                e = s.responseText.length
                                    ? { code: "HTTP_ERROR", error: "The server returned a " + s.status + " status with the following body: " + s.responseText }
                                    : {
                                          code: "HTTP_ERROR",
                                          error:
                                              "The server returned a " +
                                              s.status +
                                              " status but either the server did not return a body or this browser is a version of Internet Explorer that hides error bodies.",
                                      };
                            o.returnError(e);
                        }
                    }),
                    (s.ontimeout = function () {
                        o.returnError({ code: "HTTP_TIMEOUT", error: "The request to the GeoIP2 web service timed out." });
                    }),
                    (s.onerror = function () {
                        o.returnError({ code: "HTTP_ERROR", error: "There was a network error receiving the response from the GeoIP2 web service." });
                    }),
                    s.send(null);
            }
        }),
        (e.country = function (e, n, r) {
            new t(e, n, r, "country").getGeoIPResult();
        }),
        (e.city = function (e, n, r) {
            new t(e, n, r, "city").getGeoIPResult();
        }),
        (e.insights = function (e, n, r) {
            new t(e, n, r, "insights").getGeoIPResult();
        }),
        e
    );
})();

// ==============================================================
// Global Boulies Object
// ==============================================================
var Boulies = window.Boulies || {};
Boulies.formatPrice = function (price, rule, locale) {
    var currencySymbols = {
        GBP: "£",
        EUR: "€",
        USD: "$",
        CNY: "¥",
        JPY: "¥",
        CAD: "CAD",
        AUD: "AUD",
    };
    if (rule == "symbolOnly") {
        return currencySymbols[Shopify.currency.active];
    }
    switch (locale) {
        case "de":
        case "it":
        case "fr":
        case "es":
            return (
                (price / 100)
                    .toFixed(2)
                    .replace(".", ",")
                    .replace(/\d{1,3}(?=(\d{3})+(\,\d*)?$)/g, "$&.") + " €"
            );
        default:
            var symbol = currencySymbols[Shopify.currency.active] || "";
            if (Shopify.currency.active === "JPY") {
                // Special handling for JPY: no decimal places
                return (
                    symbol +
                    Math.round(price / 100)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                );
            }
            return symbol + (price / 100).toFixed(2).replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, "$&,");
    }
};
Boulies.toShopifyPrice = function (string) {
    return parseInt(
        parseFloat(string.replace(/[^0-9.]/gi, ""))
            .toFixed(2)
            .replace(".", "")
    );
};
Boulies.getUrlkey = function () {
    var params = {};
    if (window.location.href.indexOf("?") == -1) {
        return false;
    }
    var urls = window.location.href.split("?");
    var datas = urls[1].split("#");
    var arr = datas[0].split("&");
    for (var i = 0, l = arr.length; i < l; i++) {
        var a = arr[i].split("=");
        params[a[0]] = decodeURI(a[1]);
    }
    return params;
};
Boulies.searchSwitch = function () {
    $(".bouliesHeader_searchOpen").on("click", function () {
        $(".bouliesHeader").addClass("bouliesHeader_searchOn");
        $(".bouliesHeader_searchField").focus();
        setTimeout(function () {
            $(".bouliesHeader_searchWrap").addClass("bouliesHeader_searchOn");
        }, 350);
    });
    $(".bouliesHeader_searchColse").on("click", function () {
        $(".bouliesHeader_searchWrap").removeClass("bouliesHeader_searchOn");
        setTimeout(function () {
            $(".bouliesHeader").removeClass("bouliesHeader_searchOn");
        }, 300);
    });
    $(window).on("scroll", function () {
        $(".bouliesHeader_searchWrap").removeClass("bouliesHeader_searchOn");
        setTimeout(function () {
            $(".bouliesHeader").removeClass("bouliesHeader_searchOn");
        }, 300);
    });
};
Boulies.PopupModal = function (domElements) {
    (this.containerEl = $(domElements.container)),
        (this.bgEl = $(domElements.background)),
        (this.contentEl = $(domElements.content)),
        (this.openBTN = $(domElements.openBTN)),
        (this.closeBTN = $(domElements.closeBTN));
    this.beforeClose = domElements.beforeClose ? domElements.beforeClose : () => {};
    this.beforeOpen = domElements.beforeOpen ? domElements.beforeOpen : () => {};
    if (this.containerEl.length == 0 || this.bgEl.length == 0 || this.contentEl.length == 0 || this.openBTN.length == 0 || this.closeBTN.length == 0) {
        console.error("The main structure is incomplete, must have container, background, content and triggers");
        return false;
    }
    if (this.containerEl.length > 1 || this.bgEl.length > 1 || this.contentEl.length > 1) {
        console.error("Duplicate main structure.");
        return false;
    }
    this.initModal();
    var _this = this;
    this.openBTN.on("click", function () {
        _this.open();
    });
    this.closeBTN.on("click", function () {
        _this.close();
    });
    this.bgEl.on("click", function () {
        _this.close();
    });
};
Boulies.PopupModal.prototype = {
    initModal: function () {
        this.containerEl.css({
            position: "fixed",
            zIndex: 19996,
            top: 0,
            left: 0,
            background: "none",
            width: "100%",
            height: "100%",
            overflowY: "auto",
            overflowX: "hidden",
            display: "none",
        });
        this.bgEl.css({
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0, 0, 0, 0.84)",
            zIndex: 19997,
            opacity: 0,
            transition: "all 500ms cubic-bezier(0.4, 0, 0.2, 1)",
        });
        this.contentEl.css({
            position: "relative",
            zIndex: 19998,
            opacity: 0,
            transition: "all 500ms cubic-bezier(0.4, 0, 0.2, 1)",
            transform: "translate3d(0, 15%, 0)",
        });
    },
    open: function () {
        this.beforeOpen();
        this.containerEl.css({ display: "flex" });
        var _this = this;
        setTimeout(function () {
            _this.bgEl.css({ opacity: 1 });
            _this.contentEl.css({ transform: "translate3d(0, 0, 0)", opacity: 1 });
        }, 20);
    },
    close: function () {
        this.beforeClose();
        this.bgEl.css({ opacity: 0 });
        this.contentEl.css({ transform: "translate3d(0, 15%, 0)", opacity: 0 });
        var _this = this;
        setTimeout(function () {
            _this.containerEl.css({ display: "none" });
        }, 500);
    },
};
Boulies.detectWarrantyStatus = function (element) {
    var el = $(element),
        duration = el.attr("data-time"),
        start = el.attr("data-startat");
    if (el.length < 0 || duration.length < 0 || start.length < 0) {
        console.warn("Wrong element or didn't set [data-time]/[data-startat] correct.");
        return false;
    }
    var _start = new Date(start).getTime(),
        _end = _start + (duration / 12) * 365 * 86400000,
        _now = new Date().getTime();

    if (_end < _now) {
        el.removeClass("green").addClass("red").html("Out Warranty");
    }
};
Boulies.banDrag = function (classname) {
    if ($(classname).length < 1) return false;
    $(classname).on("mousedown", "img", function (e) {
        e.preventDefault();
    });
};
Boulies.contact = function (querys, options) {
    var querys = querys || {},
        options = options || {};
    _querys = {
        type: querys.type ? "contact%5Benquiry-type%5D=" + querys.type + "&" : "",
        email: querys.email ? "contact%5Bemail%5D=" + querys.email + "&" : "",
        name: querys.name ? "contact%5Bname%5D=" + querys.name + "&" : "",
        country: querys.country ? "contact%5Bcountry%5D=" + querys.country + "&" : "",
        product: querys.product ? "contact%5Bproduct%5D=" + querys.product + "&" : "",
        channel: querys.channel ? "contact%5Bpurchase-channel%5D=" + querys.channel + "&" : "",
        order: querys.order ? "contact%5Border-id%5D=" + querys.order + "&" : "",
        message: querys.message ? "contact%5Bmessage%5D=" + encodeURI(querys.message) + "&" : "",
    };
    _options = {
        width: options.width || 850,
        height: options.height || 500,
        left: options.left || 50,
        top: options.top || 130,
        toolbar: options.toolbar || "no",
        location: options.location || "no",
        directories: options.directories || "no",
        status: options.status || "no",
        menubar: options.menubar || "no",
        scrollbars: options.scrollbars || "yes",
        resizable: options.resizable || "no",
        copyhistory: options.copyhistory || "no",
    };
    var _link = "/pages/contact?";
    $.each(_querys, function (i, v) {
        _link += v;
    });
    var __options = JSON.stringify(_options).slice(1, -1).replace(/"/g, "").replace(/:/g, "=");
    window.open(_link.slice(0, -1), "_blank", __options);
};
Boulies.imageResize = function (imageUrl, newsize, heightOnly) {
    var a = imageUrl.split("?");
    if (!/.(gif|jpg|jpeg|png)$/.test(a[0])) {
        return imageUrl;
    }
    if (heightOnly == "heightOnly") {
        return a[0].replace(/.(gif|jpg|jpeg|png)$/, "_x" + newsize + /.(gif|jpg|jpeg|png)$/.exec(a[0])[0]) + "?" + a[1];
    } else {
        return a[0].replace(/.(gif|jpg|jpeg|png)$/, "_" + newsize + "x" + /.(gif|jpg|jpeg|png)$/.exec(a[0])[0]) + "?" + a[1];
    }
};
Boulies.DynamicLoading = {
    css: function (path) {
        if (!path || path.length === 0) {
            throw new Error('argument "path" is required !');
        }
        var head = document.getElementsByTagName("head")[0];
        var link = document.createElement("link");
        link.href = path;
        link.rel = "stylesheet";
        link.type = "text/css";
        head.appendChild(link);
    },
    js: function (path) {
        if (!path || path.length === 0) {
            throw new Error('argument "path" is required !');
        }
        var head = document.getElementsByTagName("head")[0];
        var script = document.createElement("script");
        script.src = path;
        script.type = "text/javascript";
        head.appendChild(script);
    },
};


// ==============================================================
// Header Nav Function
// ==============================================================
var headerNav = function () {
    var slider_menu = document.querySelector(".bt5-slider-menu");
    var catalog_triggers = document.querySelectorAll(".js-catalog-trigger");
    var catalog_list = document.querySelectorAll(".js-catalog-list");
    document.querySelector(".js-slider-close-trigger").addEventListener("click", function () {
        slider_menu.dataset.state = "";
        document.body.classList.remove("bouliesNoscroll");
        setTimeout(function () {
            slider_menu.style.display = "none";
        }, 400);
    });
    document.querySelector(".js-slider-active-trigger").addEventListener("click", function () {
        slider_menu.style.display = "block";
        document.body.classList.add("bouliesNoscroll");
        setTimeout(function () {
            slider_menu.dataset.state = "is_actived";
        }, 50);
    });
    document.querySelector(".bouliesFooter_quickLinkWrap").addEventListener("click", function (e) {
        var item = e.target.closest(".bouliesFooter_quickLink");
        if (!item) return;
        if (!document.querySelector(".bouliesFooter_quickLinkWrap").contains(item)) return;
        item.classList.toggle("bouliesFooter_quickLinkOn");
    });
    document.querySelector(".bt5-slider-catalog__lines").addEventListener("click", function (e) {
        var trigger = e.target.closest(".js-catalog-trigger");
        if (!trigger) return;
        catalog_triggers.forEach(function (t) {
            t.dataset.state = "";
        });
        trigger.dataset.state = "is_actived";
        catalog_list.forEach(function (l) {
            if (l.dataset.tab == trigger.dataset.tab) {
                l.dataset.state = "is_actived";
            } else {
                l.dataset.state = "";
            }
        });
    });
};


// ==============================================================
// Boulies Ajax Cart Function
// ==============================================================
var ajaxcart = {
    cartWrap: document.querySelector(".bouliesCartWrap"),
    cartItemNum: document.querySelector(".bt5-cart-item-num"),
    isUpdatingQuantity: false,
    isNormalizingFreeWarranty: false,
    quantityUpdateAvailableAt: 0,
    quantityUpdateCooldown: 800,
    init: function () {
        ajaxcart.getCartItem();

        document.querySelector(".js-cart-trigger").addEventListener("click", function () {
            ajaxcart.openCart();
        });

        document.querySelector(".bouliesCartWrap").addEventListener("click", function (e) {
            if (!e.target) {
                alert("古いブラウザの機能制限とは、主にウェブサイトが提供する部分の機能や仕様にアクセスできません。");
                return false;
            }
            var target = e.target;
            if (target.classList.contains("bouliesCartWrap")) {
                ajaxcart.closeCart();
                return;
            }
            for (var i = 0; i < 4; i++) {
                if (target.classList.contains("bouliesCartCloseTrigger")) {
                    ajaxcart.closeCart();
                    return;
                }
                if (target.nodeName == "LI") {
                    target.classList.toggle("bc_faqQuestionClosed");
                    return;
                }
                target = target.parentNode;
            }
        });
    },
    openCart: function () {
        if (ajaxcart.cartWrap.classList.contains("bouliesCartLoaded")) return false;
        ajaxcart.cartWrap.style["display"] = "block";
        document.documentElement.classList.add("bouliesNoscroll");
        setTimeout(function () {
            ajaxcart.cartWrap.classList.add("bouliesCartLoaded");
        }, 20);
    },
    closeCart: function () {
        if (!ajaxcart.cartWrap.classList.contains("bouliesCartLoaded")) return false;
        ajaxcart.cartWrap.classList.remove("bouliesCartLoaded");
        setTimeout(function () {
            ajaxcart.cartWrap.style["display"] = "none";
            document.documentElement.classList.remove("bouliesNoscroll");
        }, 500);
    },
    getCartItem: function () {
        $.ajax({
            type: "GET",
            url: "/cart.js",
            dataType: "JSON",
            timeout: 8000,
            success: function (cartData) {
                ajaxcart.updateCartItem(cartData);
            },
        });
    },
    itemText: function (item) {
        return [item.product_title, item.variant_title, item.handle, item.url].filter(Boolean).join(" ").toLowerCase();
    },
    isWarrantyItem: function (item) {
        return /warranty|guarantee|保証/.test(ajaxcart.itemText(item));
    },
    isWarrantyAddon: function (item) {
        return !!(item && item.product_type === "Addon" && ajaxcart.isWarrantyItem(item));
    },
    isFreeWarrantyAddon: function (item) {
        var linePrice = Number(item && (item.final_line_price != null ? item.final_line_price : item.line_price));
        return !!(ajaxcart.isWarrantyAddon(item) && !isNaN(linePrice) && linePrice <= 0);
    },
    isWarrantyEligibleChair: function (item) {
        return !!(item && item.product_type === "Chair");
    },
    getFreeWarrantyAdjustment: function (cartData) {
        var chairQuantity = 0,
            warrantyQuantity = 0,
            freeWarrantyItems = [];

        if (!cartData || !cartData.items) return null;

        cartData.items.forEach(function (item) {
            if (ajaxcart.isWarrantyEligibleChair(item)) {
                chairQuantity += item.quantity;
            }
            if (ajaxcart.isFreeWarrantyAddon(item)) {
                warrantyQuantity += item.quantity;
                freeWarrantyItems.push(item);
            }
        });

        if (chairQuantity < 1 || warrantyQuantity <= chairQuantity) return null;

        var overQuantity = warrantyQuantity - chairQuantity;
        for (var i = freeWarrantyItems.length - 1; i >= 0; i--) {
            var freeWarrantyItem = freeWarrantyItems[i],
                reduceQuantity = Math.min(overQuantity, freeWarrantyItem.quantity),
                newQuantity = freeWarrantyItem.quantity - reduceQuantity;

            if (reduceQuantity > 0) {
                return {
                    id: freeWarrantyItem.key || freeWarrantyItem.id,
                    quantity: newQuantity,
                };
            }
        }

        return null;
    },
    getWarrantyOnlyAdjustment: function (cartData) {
        var warrantyItems = [],
            hasNonWarrantyItem = false;

        if (!cartData || !cartData.items) return null;

        cartData.items.forEach(function (item) {
            if (ajaxcart.isWarrantyAddon(item)) {
                warrantyItems.push(item);
            } else if (item.quantity > 0) {
                hasNonWarrantyItem = true;
            }
        });

        if (hasNonWarrantyItem) return null;

        for (var i = 0; i < warrantyItems.length; i++) {
            var warrantyItem = warrantyItems[i];

            if (warrantyItem.quantity > 1) {
                return {
                    id: warrantyItem.key || warrantyItem.id,
                    quantity: 1,
                };
            }
        }

        return null;
    },
    withAdjustedItemQuantity: function (cartData, targetItem, quantity) {
        if (!cartData || !cartData.items) return { items: [] };

        return {
            items: cartData.items.map(function (item) {
                var adjustedItem, key;
                if (item !== targetItem) return item;

                adjustedItem = {};
                for (key in item) {
                    if (Object.prototype.hasOwnProperty.call(item, key)) {
                        adjustedItem[key] = item[key];
                    }
                }
                adjustedItem.quantity = quantity;
                return adjustedItem;
            }),
        };
    },
    normalizeFreeWarrantyQuantity: function (cartData) {
        if (ajaxcart.isNormalizingFreeWarranty) return false;

        var adjustment = ajaxcart.getWarrantyOnlyAdjustment(cartData) || ajaxcart.getFreeWarrantyAdjustment(cartData);
        if (!adjustment) return false;

        ajaxcart.isNormalizingFreeWarranty = true;
        var normalizedCartData = null,
            shouldSkipNormalize = false;
        $.ajax({
            type: "POST",
            dataType: "JSON",
            url: "/cart/change.js",
            data: { quantity: adjustment.quantity, id: adjustment.id },
            timeout: 8000,
            success: function (updatedCartData) {
                normalizedCartData = updatedCartData;
            },
            error: function () {
                normalizedCartData = cartData;
                shouldSkipNormalize = true;
            },
            complete: function () {
                ajaxcart.isNormalizingFreeWarranty = false;
                ajaxcart.updateCartItem(normalizedCartData || cartData, shouldSkipNormalize);
            },
        });

        return true;
    },
    updateCartItem: function (cartData, skipFreeWarrantyNormalize) {
        // console.log("cartData:", cartData);
        if (!skipFreeWarrantyNormalize && ajaxcart.normalizeFreeWarrantyQuantity(cartData)) return false;

        // Update cart item count UI
        if (cartData.item_count < 1) {
            ajaxcart.cartWrap.classList.add("cartIsEmpty");
            ajaxcart.cartItemNum.dataset.cartNum = "";
            document.querySelector("#bc_calcWrap").innerHTML = "";
            return false;
        }
        ajaxcart.cartWrap.classList.remove("cartIsEmpty");
        ajaxcart.cartItemNum.dataset.cartNum = "is_actived";
        ajaxcart.cartItemNum.dataset.num = cartData.item_count;

        // Render html
        var lineItems = "",
            cart_discount = "";
        cartData.items.forEach(function (v) {
            if (v.properties == null) {
                v.properties = {};
            }
            var _lineItemKey = v.key || v.id,
                _lineItemId = "lineItem_" + String(_lineItemKey).replace(/[^A-Za-z0-9_-]/g, "_"),
                _lineItemKeyParam = "'" + String(_lineItemKey).replace(/\\/g, "\\\\").replace(/'/g, "\\'") + "'",
                _lineItemIdParam = "'" + _lineItemId.replace(/\\/g, "\\\\").replace(/'/g, "\\'") + "'",
                _preorderValue = v.properties["出荷予定日"] || v.properties["Estimated_to_ship_out"],
                _accessoriesValue = v.properties["プレゼント"] || v.properties["accessories"],
                _cartDataWithNextQuantity = ajaxcart.withAdjustedItemQuantity(cartData, v, v.quantity + 1),
                _isLimitedWarrantyOnly = ajaxcart.isWarrantyAddon(v) && !!ajaxcart.getWarrantyOnlyAdjustment(_cartDataWithNextQuantity),
                _isLimitedFreeWarranty = ajaxcart.isFreeWarrantyAddon(v) && !!ajaxcart.getFreeWarrantyAdjustment(_cartDataWithNextQuantity),
                _isLimitedWarranty = _isLimitedWarrantyOnly || _isLimitedFreeWarranty;
            // add preorder info
            var _preorderInfo = _preorderValue
                ? '<tr class="bc_preorder"><td><span class="bt51-cart-warning-label">予約注文情報</span></td><td>出荷予定日：' +
                  String(_preorderValue).replace(/^出荷予定日\s*/, "") +
                  "</td></tr>"
                : "";
            // add desk package info
            let _packageInfo = v.product_type === "Desk" ? '<tr><td colspan="2" class="bc_lineItemDescription">別々発送 2回に分けて</td></tr>' : "";
            // add addon label
            let _addonLabel =
                v.product_type === "Addon"
                    ? '<div class="bc_preorderedLabel" style="background-color: #000000;color: #ffffff;"><span>オ</span><span>プ</span><span>シ</span><span>ョ</span><span>ン</span><span>サ</span><span>ー</span><span>ビ</span><span>ス</span></div>'
                    : "";
            // add preorder label
            let _preorderLabel = _preorderValue
                ? '<div class="bc_preorderedLabel"><span>予</span><span>約</span><span>商</span><span>品</span></div>'
                : "";
            let _labelHtml = _addonLabel + _preorderLabel;

            var _variantTitle = v.variant_title ? '<span class="bc_itemVariants">' + v.variant_title + "</span>" : "";
            var _accessories = _accessoriesValue
                ? '<tr class="bc_accessories"><td><span class="bt51-cart-label">プレゼント</span></td><td>' + _accessoriesValue + "</td></tr>"
                : "";
            var _freeWarrantyLimitInfo = ajaxcart.isFreeWarrantyAddon(v)
                ? '<tr class="bc_accessories"><td><span class="bt51-cart-label">無料保証</span></td><td>対象チェア1点につき、1回限りご利用いただけます。</td></tr>'
                : "";
            var _description = v.requires_shipping ? "" : '<tr><td colspan="2" class="bc_lineItemDescription">' + v.product_description + "</td></tr>";
            var _url = v.product_type == "Addon" ? "javascript:void(0);" : v.url;
            var _quantityHtml = _isLimitedWarranty
                ? '<div class="bc_quantityWrap">\
                                            <span class="bc_quantityAdjust" data-quantityAdjust="minus" onclick="ajaxcart.updateItemQuantity(' +
                  _lineItemKeyParam +
                  ", " +
                  (v.quantity - 1) +
                  ", " +
                  _lineItemIdParam +
                  ')"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="14" height="14" viewBox="0 0 24 24"><g><path fill="#000" d="M4,12C4,11.447715,4.447715,11,5,11C5,11,19,11,19,11C19.552300000000002,11,20,11.447715,20,12C20,12.55228,19.552300000000002,13,19,13C19,13,5,13,5,13C4.447715,13,4,12.55228,4,12C4,12,4,12,4,12Z"/></g></svg></span>\
                                            <input value="' +
                  v.quantity +
                  '" min="1" autocomplete="off" name="updateQuantity" type="number" class="bc_quantityDirectAdjust" readonly data-id="' +
                  _lineItemKey +
                  '" data-idClass="' +
                  _lineItemId +
                  '">\
                                        </div>'
                : '<div class="bc_quantityWrap">\
                                            <span class="bc_quantityAdjust" data-quantityAdjust="minus" onclick="ajaxcart.updateItemQuantity(' +
                  _lineItemKeyParam +
                  ", " +
                  (v.quantity - 1) +
                  ", " +
                  _lineItemIdParam +
                  ')"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="14" height="14" viewBox="0 0 24 24"><g><path fill="#000" d="M4,12C4,11.447715,4.447715,11,5,11C5,11,19,11,19,11C19.552300000000002,11,20,11.447715,20,12C20,12.55228,19.552300000000002,13,19,13C19,13,5,13,5,13C4.447715,13,4,12.55228,4,12C4,12,4,12,4,12Z"/></g></svg></span>\
                                            <input onkeydown="if(event.keyCode==13){event.preventDefault();ajaxcart.updateItemQuantity(' +
                  _lineItemKeyParam +
                  ',this.value,' +
                  _lineItemIdParam +
                  ')}" value="' +
                  v.quantity +
                  '" min="1" autocomplete="off" name="updateQuantity" type="number" class="bc_quantityDirectAdjust"  data-id="' +
                  _lineItemKey +
                  '" data-idClass="' +
                  _lineItemId +
                  '">\
                                            <span class="bc_quantityAdjust" data-quantityAdjust="plus" onclick="ajaxcart.updateItemQuantity(' +
                  _lineItemKeyParam +
                  ", " +
                  (v.quantity + 1) +
                  ", " +
                  _lineItemIdParam +
                  ')"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="14" height="14" viewBox="0 0 24 24"><g><path fill="#000" d="M12,4C12.55228,4,13,4.447715,13,5C13,5,13,11,13,11C13,11,19,11,19,11C19.552300000000002,11,20,11.44772,20,12C20,12.55228,19.552300000000002,13,19,13C19,13,13,13,13,13C13,13,13,19,13,19C13,19.552300000000002,12.55228,20,12,20C11.44772,20,11,19.552300000000002,11,19C11,19,11,13,11,13C11,13,5,13,5,13C4.447715,13,4,12.55228,4,12C4,11.44772,4.447715,11,5,11C5,11,11,11,11,11C11,11,11,5,11,5C11,4.447715,11.44772,4,12,4C12,4,12,4,12,4Z"/></g></svg></span>\
                                        </div>';
            var _discounts = "";
            if (v.line_level_discount_allocations.length > 0) {
                _discounts = '<span class="bc_itemOriginalPrice">' + Boulies.formatPrice(v.original_line_price) + "</span>";
                v.line_level_discount_allocations.forEach(function (discount) {
                    _discounts +=
                        '<span class="bc_itemDiscount"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18"> <path d="M17.78 3.09C17.45 2.443 16.778 2 16 2h-5.165c-.535 0-1.046.214-1.422.593l-6.82 6.89c0 .002 0 .003-.002.003-.245.253-.413.554-.5.874L.738 8.055c-.56-.953-.24-2.178.712-2.737L9.823.425C10.284.155 10.834.08 11.35.22l4.99 1.337c.755.203 1.293.814 1.44 1.533z" fill="#a5a5a5"></path> <path d="M10.835 2H16c1.105 0 2 .895 2 2v5.172c0 .53-.21 1.04-.586 1.414l-6.818 6.818c-.777.778-2.036.782-2.82.01l-5.166-5.1c-.786-.775-.794-2.04-.02-2.828.002 0 .003 0 .003-.002l6.82-6.89C9.79 2.214 10.3 2 10.835 2zM13.5 8c.828 0 1.5-.672 1.5-1.5S14.328 5 13.5 5 12 5.672 12 6.5 12.672 8 13.5 8z" fill="#656565"></path></svg>' +
                        discount.discount_application.title +
                        "<br>" +
                        " (-" +
                        Boulies.formatPrice(discount.amount) +
                        ")</span>";
                });
            }
            lineItems +=
                '<div class="bc_listedItem" id="' +
                _lineItemId +
                '">' +
                _labelHtml +
                '<div class="bc_itemImageWrap">\
                                <img src="' +
                Boulies.imageResize(v.image, 300) +
                '">\
                            </div>\
                            <div class="bc_itemInfoWrap">\
                                <div class="bc_itemInfo">\
                                    <h2 class="bc_itemTitle">\
                                        <a href="' +
                _url +
                '">' +
                v.product_title +
                "</a>\
                                    </h2>" +
                _variantTitle +
                '<table class="bc_itemSpecification">' +
                _packageInfo +
                _description +
                _accessories +
                _freeWarrantyLimitInfo +
                _preorderInfo +
                '</table>\
                                </div>\
                                <div class="bc_itemPriceInfo">\
                                    <div class="bc_itemQuantity">\
                                        ' +
                _quantityHtml +
                '\
                                    </div>\
                                    <div class="bc_itemPrice">' +
                _discounts +
                '<span style="margin-top:0.2em;display:block;">' +
                Boulies.formatPrice(v.line_price) +
                "</span>\
                                    </div>\
                                </div>\
                            </div>\
                        </div>";
        });
        document.querySelector("#bouliesAjaxCart_DataWrap").innerHTML = lineItems;
        document.querySelector("#bc_calcWrap").innerHTML = "";
        if (cartData.total_discount > 0) {
            cart_discount +=
                '<p><span>小計</span><span class="bc_calcPrice bc_oriSubTotal" >' + Boulies.formatPrice(cartData.original_total_price) + "</span></p>";
            if (cartData.cart_level_discount_applications.length > 0) {
                cartData.cart_level_discount_applications.forEach(function (discount) {
                    if (discount.discount_application) {
                        cart_discount +=
                            '<p><span>特別クーポン (<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" style="width: 13px;position: relative;top: 2px;"> <path d="M17.78 3.09C17.45 2.443 16.778 2 16 2h-5.165c-.535 0-1.046.214-1.422.593l-6.82 6.89c0 .002 0 .003-.002.003-.245.253-.413.554-.5.874L.738 8.055c-.56-.953-.24-2.178.712-2.737L9.823.425C10.284.155 10.834.08 11.35.22l4.99 1.337c.755.203 1.293.814 1.44 1.533z" fill="#a5a5a5"></path> <path d="M10.835 2H16c1.105 0 2 .895 2 2v5.172c0 .53-.21 1.04-.586 1.414l-6.818 6.818c-.777.778-2.036.782-2.82.01l-5.166-5.1c-.786-.775-.794-2.04-.02-2.828.002 0 .003 0 .003-.002l6.82-6.89C9.79 2.214 10.3 2 10.835 2zM13.5 8c.828 0 1.5-.672 1.5-1.5S14.328 5 13.5 5 12 5.672 12 6.5 12.672 8 13.5 8z" fill="#656565"></path> </svg> ' +
                            discount.discount_application.title +
                            ')</span><span class="bc_calcPrice bc_discountAmount">-' +
                            Boulies.formatPrice(discount.discount_application.total_allocated_amount) +
                            "</span></p>";
                    } else {
                        cart_discount +=
                            '<p><span>特別クーポン (<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" style="width: 13px;position: relative;top: 2px;"> <path d="M17.78 3.09C17.45 2.443 16.778 2 16 2h-5.165c-.535 0-1.046.214-1.422.593l-6.82 6.89c0 .002 0 .003-.002.003-.245.253-.413.554-.5.874L.738 8.055c-.56-.953-.24-2.178.712-2.737L9.823.425C10.284.155 10.834.08 11.35.22l4.99 1.337c.755.203 1.293.814 1.44 1.533z" fill="#a5a5a5"></path> <path d="M10.835 2H16c1.105 0 2 .895 2 2v5.172c0 .53-.21 1.04-.586 1.414l-6.818 6.818c-.777.778-2.036.782-2.82.01l-5.166-5.1c-.786-.775-.794-2.04-.02-2.828.002 0 .003 0 .003-.002l6.82-6.89C9.79 2.214 10.3 2 10.835 2zM13.5 8c.828 0 1.5-.672 1.5-1.5S14.328 5 13.5 5 12 5.672 12 6.5 12.672 8 13.5 8z" fill="#656565"></path> </svg> ' +
                            discount.title +
                            ')</span><span class="bc_calcPrice bc_discountAmount">-' +
                            Boulies.formatPrice(discount.total_allocated_amount) +
                            "</span></p>";
                    }
                });
            }
            cart_discount +=
                '<p><span>クーポン</span><span class="bc_calcPrice bc_discountAmount">-' + Boulies.formatPrice(cartData.total_discount) + "</span></p> ";
            document.querySelector("#bc_calcWrap").innerHTML = cart_discount;
        }
        document.querySelector("#bouliesAjaxCart_totalPrice").innerHTML = Boulies.formatPrice(cartData.total_price);
    },
    updateItemQuantity: function (id, num, lineItemId) {
        if (ajaxcart.isUpdatingQuantity) return false;
        num = parseInt(num, 10);
        if (isNaN(num) || num < 0) return false;
        var now = Date.now();
        if (now < ajaxcart.quantityUpdateAvailableAt) return false;
        ajaxcart.quantityUpdateAvailableAt = now + ajaxcart.quantityUpdateCooldown;
        ajaxcart.isUpdatingQuantity = true;
        var lineItem = lineItemId ? document.getElementById(lineItemId) : document.getElementById("lineItem_" + id);
        $.ajax({
            type: "POST",
            dataType: "JSON",
            url: "/cart/change.js",
            data: { quantity: num, id: id },
            timeout: 8000,
            success: function (cartData) {
                if (cartData.item_count < 1) {
                    ajaxcart.cartWrap.classList.add("cartIsEmpty");
                    ajaxcart.cartItemNum.dataset.cartNum = "";
                    document.querySelector("#bouliesAjaxCart_DataWrap").innerHTML = "";
                    document.querySelector("#bc_calcWrap").innerHTML = "";
                    document.querySelector("#bouliesAjaxCart_totalPrice").innerHTML = Boulies.formatPrice(cartData.total_price);
                    ajaxcart.isUpdatingQuantity = false;
                    return false;
                }

                ajaxcart.updateCartItem(cartData);
                ajaxcart.cartWrap.classList.remove("cartIsEmpty");
                ajaxcart.cartItemNum.dataset.cartNum = "is_actived";
                ajaxcart.cartItemNum.dataset.num = cartData.item_count;
            },
            error: function (e) {
                var isNetworkGuardError = e && (e.status == 403 || e.status == 429 || e.statusText == "timeout");
                alert(isNetworkGuardError ? "アクセスが集中しています。時間をおいて再度お試しください。" : e && e.responseJSON && e.responseJSON.message ? e.responseJSON.message : "カート商品の更新に失敗しました。時間をおいて再度お試しください。");
                if (!isNetworkGuardError) {
                    window.setTimeout(function () {
                        ajaxcart.getCartItem();
                    }, 1000);
                }
            },
            beforeSend: function () {
                if (lineItem) lineItem.classList.add("bc_updatingQuantity");
            },
            complete: function () {
                if (lineItem) lineItem.classList.remove("bc_updatingQuantity");
                ajaxcart.isUpdatingQuantity = false;
                ajaxcart.quantityUpdateAvailableAt = Date.now() + ajaxcart.quantityUpdateCooldown;
            },
        });
    },
};


// ==============================================================
// check footer newsletter
// ==============================================================
var newsLetterCheck = function () {
    var reg = /^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/;
    $(".bouliesNewsLetterSubmitButton").on("click", function (e) {
        console.log("checking");
        console.log($(".bouliesNewsLetterInput").val());
        if ($(".bouliesNewsLetterInput").val() == "") {
            $(".bouliesNewsLetterForm ").addClass("errors");
            console.log("NG");
            e.preventDefault();
            return false;
        } else if (!reg.test($(".bouliesNewsLetterInput").val())) {
            $(".bouliesNewsLetterForm ").addClass("errors");
            console.log("NG");
            e.preventDefault();
            return false;
        } else {
            $(".bouliesNewsLetterForm ").removeClass("errors");
            console.log("OK");
        }
    });
};


// ==============================================================
// Geo Modal(check target shop and locale)
// ==============================================================
var bouliesGeo = function () {
    var shops = {
        // 'EU': { name: 'Boulies Chairs EU', url: 'https://boulies.eu', currency: 'EUR', currencySymbol: '€' },
        // 'DE': { name: 'Boulies Chairs DE', url: 'https://boulies.de/de', currency: 'EUR', currencySymbol: '€' },
        // 'IE': { name: 'Boulies Chairs IE', url: 'https://boulies.ie', currency: 'EUR', currencySymbol: '€' },
        // 'CA': { name: 'Boulies Chairs CA', url: 'https://boulies.ca', currency: 'CAD', currencySymbol: '$' },
        UK: { name: "Boulies Chairs UK", url: "https://boulies.co.uk", currency: "GBP", currencySymbol: "£" },
        US: { name: "Boulies Chairs US", url: "https://boulies.com", currency: "USD", currencySymbol: "$" },
        AU: { name: "Boulies Chairs AU", url: "https://au.boulies.com", currency: "AUD", currencySymbol: "$" },
    };
    var serviceRegion = {
        GB: { targetShop: "UK", locale: "en" },
        US: { targetShop: "US", locale: "en" },
        AU: { targetShop: "AU", locale: "en" },
        CA: { targetShop: "CA", locale: "en" },
        AD: { targetShop: "EU", locale: "en" },
        AT: { targetShop: "EU", locale: "de" },
        BE: { targetShop: "EU", locale: "fr" },
        CY: { targetShop: "EU", locale: "en" },
        EE: { targetShop: "EU", locale: "en" },
        FI: { targetShop: "EU", locale: "en" },
        FR: { targetShop: "EU", locale: "fr" },
        DE: { targetShop: "DE", locale: "de" },
        GR: { targetShop: "EU", locale: "en" },
        IE: { targetShop: "IE", locale: "en" },
        IT: { targetShop: "EU", locale: "it" },
        RS: { targetShop: "EU", locale: "en" },
        LV: { targetShop: "EU", locale: "en" },
        LT: { targetShop: "EU", locale: "en" },
        LI: { targetShop: "EU", locale: "de" },
        LU: { targetShop: "EU", locale: "fr" },
        MT: { targetShop: "EU", locale: "en" },
        MC: { targetShop: "EU", locale: "fr" },
        ME: { targetShop: "EU", locale: "en" },
        NL: { targetShop: "EU", locale: "de" },
        PT: { targetShop: "EU", locale: "en" },
        SM: { targetShop: "EU", locale: "it" },
        SK: { targetShop: "EU", locale: "en" },
        SI: { targetShop: "EU", locale: "en" },
        ES: { targetShop: "EU", locale: "es" },
        CH: { targetShop: "EU", locale: "de" },
    };

    // create recommend modal dom
    var recModalContainer = document.createElement("div"),
        recModalBackdrop = document.createElement("div"),
        recModalContent = document.createElement("div"),
        recModalClosebtn = document.createElement("button"),
        recModalminimal = document.createElement("button");
    recModalContainer.setAttribute("class", "recommendation-modal__container");
    recModalBackdrop.setAttribute("class", "recommendation-modal__backdrop");
    recModalClosebtn.setAttribute("class", "recommendation-modal__close-button");
    recModalClosebtn.setAttribute("type", "button");
    recModalminimal.setAttribute("class", "recommendation-modal__button--minimal");
    recModalminimal.setAttribute("type", "button");
    recModalClosebtn.innerHTML =
        '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M11.414 10l6.293-6.293a.999.999 0 1 0-1.414-1.414L10 8.586 3.707 2.293a.999.999 0 1 0-1.414 1.414L8.586 10l-6.293 6.293a.999.999 0 1 0 1.414 1.414L10 11.414l6.293 6.293a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414L11.414 10z" fill="#292929"></path></svg>';
    recModalContent.setAttribute("class", "recommendation-modal__content");

    var showGeoModal = function () {
        recModalContainer.innerHTML = '<div class="recommendation-modal__close-button-container"></div>';
        recModalContainer.getElementsByTagName("div")[0].appendChild(recModalClosebtn);
        recModalContainer.appendChild(recModalContent);
        document.body.appendChild(recModalContainer);
        document.body.appendChild(recModalBackdrop);
        recModalBackdrop.style["display"] = "block";
        recModalContainer.style["display"] = "block";
        setTimeout(function () {
            document.body.classList.toggle("geoModal_actived");
        }, 300);
    };

    var closeGeoModal = function () {
        document.body.classList.toggle("geoModal_actived");
        $.cookie("bouliesGeo_location", "not set", {
            expires: 3,
            path: "/",
        });
        setTimeout(function () {
            recModalContainer.remove();
            recModalBackdrop.remove();
        }, 300);
    };

    recModalClosebtn.addEventListener("click", function () {
        closeGeoModal();
    });

    recModalBackdrop.addEventListener("click", function () {
        closeGeoModal();
    });

    recModalminimal.addEventListener("click", function () {
        closeGeoModal();
    });

    var recommendation = function (country) {
        if (country.iso_code in serviceRegion) {
            var _targetShop = serviceRegion[country.iso_code].targetShop,
                _targetLocale = serviceRegion[country.iso_code].locale;
            var locale = {
                title: {
                    de: shops[_targetShop].name + ' versendet nach <span class="recommendation-modal__message--bold">' + country.names.de + "</span>",
                    fr:
                        shops[_targetShop].name +
                        ' envoie vers le pays suivant : <span class="recommendation-modal__message--bold">' +
                        country.names.fr +
                        "</span>",
                    es: shops[_targetShop].name + ' versendet nach <span class="recommendation-modal__message--bold">' + country.names.es + "</span>",
                    it: shops[_targetShop].name + ' versendet nach <span class="recommendation-modal__message--bold">' + country.names.en + "</span>",
                    en: shops[_targetShop].name + ' ships to <span class="recommendation-modal__message--bold">' + country.names.en + "</span>",
                },
                pointing: {
                    de: "Möchten Sie zum empfohlenen Shop wechseln?",
                    fr: "Voulez-vous passer au magasin recommandé ?",
                    es: "¿Quieres cambiarte a la tienda recomendada?",
                    it: "Vuoi passare al negozio consigliato?",
                    en: "Do you want to switch to the recommended store?",
                },
                button_go: {
                    de: "Jetzt einkaufen",
                    fr: "Acheter maintenant",
                    es: "Comprar ya",
                    it: "Acquista ora",
                    en: "Shop Now",
                },
                button_stay: {
                    de: "Ich möchte auf dieser Website bleiben",
                    fr: "Je veux rester sur ce site",
                    es: "Quiero quedarme en este sitio web",
                    it: "Voglio rimanere su questo sito",
                    en: "I want to stay on this site",
                },
            };

            var targetLocaleDom = _targetLocale == "en" ? "" : _targetLocale;
            var recModalDom =
                '<div class="recommendation-modal__flag">\
                    <img src="https://cdn.shopify.com/static/images/flags/' +
                country.iso_code.toLowerCase() +
                '.svg">\
                </div>\
                <h2 class="recommendation-modal__message">' +
                locale.title[_targetLocale] +
                '</h2>\
                <div class="recommendation-modal__benefits">' +
                locale.pointing[_targetLocale] +
                '</div>\
                <a href="' +
                shops[_targetShop].url +
                "/" +
                targetLocaleDom +
                '" class="recommendation-modal__button" type="submit">' +
                locale.button_go[_targetLocale] +
                "</a>";

            recModalminimal.innerHTML = locale.button_stay[_targetLocale];
            recModalContent.innerHTML = recModalDom;
            recModalContent.appendChild(recModalminimal);
            showGeoModal();
        } else {
            var recModalDom =
                '<div class="recommendation-modal__flag">\
                    <img src="https://cdn.shopify.com/static/images/flags/' +
                country.iso_code.toLowerCase() +
                '.svg">\
                </div>\
                <h2 class="recommendation-modal__message">We can\'t deliver our products to your location.</h2>\
                <div class="recommendation-modal__benefits">Seems you are in ' +
                country.names.en +
                ", we can't ship to your region now, but you can still visit our site and contact us if you have any questions.</div>";

            recModalminimal.innerHTML = "Stay and continue to browse this website ";
            recModalContent.innerHTML = recModalDom;
            recModalContent.appendChild(recModalminimal);
            showGeoModal();
        }
    };

    var judgeLocation = function (location) {
        if (Boulies.getUrlkey().redirect == "true") {
            $.cookie("bouliesGeo_location", location.country.iso_code, { expires: 3, path: "/" });
            return false;
        }

        if (location.country.iso_code in serviceRegion) {
            // judge the recommand shop is match current shop
            if (serviceRegion[location.country.iso_code].targetShop == Boulies.setting.region.toUpperCase()) {
                $.cookie("bouliesGeo_location", location.country.iso_code, { expires: 3, path: "/" });
            } else {
                recommendation(location.country);
            }
        } else {
            recommendation(location.country);
        }
    };

    if (Boulies.getUrlkey().geotest) {
        judgeLocation({
            country: {
                iso_code: Boulies.getUrlkey().geotest,
                names: {
                    en: "Test Mode(en):" + Boulies.getUrlkey().geotest,
                    de: "Test Mode(de):" + Boulies.getUrlkey().geotest,
                    es: "Test Mode(es):" + Boulies.getUrlkey().geotest,
                    fr: "Test Mode(fr):" + Boulies.getUrlkey().geotest,
                    it: "Test Mode(it):" + Boulies.getUrlkey().geotest,
                },
            },
        });
        console.log($.cookie("bouliesGeo_location"));
        return false;
    }
    // This function only check target shop and locale when customer first access this site
    // if the value of cookie (_geoip_targetshop) is valid, then this is not first access.
    if ($.cookie("bouliesGeo_location")) return false;

    // another geoip location service 50k/M free
    // $.get("https://ipinfo.io/json?token=5f8937e6a213f2", function (response) {
    // }, "jsonp");

    geoip2.country(
        function (result) {
            if (!result) return console.warn("No info form GeoIP");
            if (!result.country) return console.warn("No country info form GeoIP");
            judgeLocation(result);
        },
        function (err) {
            console.log(err);
        }
    );
};


// ==============================================================
// GDPR cookie warn
// ==============================================================
var bouliesGDPR = function () {
    if ($.cookie("boulies_GDPR_showed")) return false;
    var gdprContainer = document.createElement("div");
    gdprContainer.className = "bouliesCookieWarnWrap";
    gdprContainer.style["display"] = "block";
    gdprContainer.innerHTML =
        '<p>This website uses cookies to ensure you get the best experience on our website. <a href="/pages/privacy#bouliesCookiesPolicy" target="_blank">Learn more</a></p>\
        <p><a class="bcww_close bcww_deny" href="javascript:void(0)">Deny Cookies</a><a class="bcww_close bcww_accept" href="javascript:void(0)" onclick="consentGrantedAdStorage()">OK</a></p>';
    document.body.appendChild(gdprContainer);
    gdprContainer.querySelectorAll(".bcww_close").forEach((v) => {
        v.addEventListener("click", () => {
            gdprContainer.classList.toggle("bouliesCookieWarnWrapShow");
            setTimeout(function () {
                gdprContainer.remove();
                $.cookie("boulies_GDPR_showed", true, {
                    expires: 30,
                    path: "/",
                });
            }, 700);
        });
    });
    setTimeout(function () {
        gdprContainer.classList.toggle("bouliesCookieWarnWrapShow");
    }, 50);
    setTimeout(function () {
        if (gdprContainer.classList.contains("bouliesCookieWarnWrapShow")) {
            gdprContainer.classList.toggle("bouliesCookieWarnWrapShow");
            setTimeout(function () {
                gdprContainer.remove();
            }, 700);
        }
        consentGrantedAdStorage();
    }, 15000);
};


// ==============================================================
// Run Code After Document Ready
// ==============================================================
$(document).ready(function () {
    // bouliesGeo();
    // JP DONT NEED
    // bouliesGDPR();
    headerNav();
    ajaxcart.init();
    newsLetterCheck();
    Boulies.banDrag(".imageDragBanned");

    if (Boulies.getUrlkey().opencart == "true") ajaxcart.openCart();

    var lazyLoadInstance = new LazyLoad();

    var scrollToTopButton = document.getElementById("scroll-to-top-btn");
    var scrollToTopMedia = window.matchMedia ? window.matchMedia("(min-width: 651px)") : null;
    var scrollToTopTicking = false;

    function getTranslateY(element) {
        var transform = window.getComputedStyle(element).transform;
        var values;
        if (!transform || transform == "none") return 0;

        if (transform.indexOf("matrix3d(") == 0) {
            values = transform.slice(9, -1).split(",");
            return parseFloat(values[13]) || 0;
        }
        if (transform.indexOf("matrix(") == 0) {
            values = transform.slice(7, -1).split(",");
            return parseFloat(values[5]) || 0;
        }
        return 0;
    }

    function updateInboxBottomOffset() {
        var chatHost = document.querySelector("shopify-chat");
        if (!chatHost) {
            document.documentElement.style.removeProperty("--b5-inbox-bottom-offset");
            return;
        }

        var chatRoot = chatHost.shadowRoot;
        var chatRuntime = chatRoot ? chatRoot.querySelector("shopify-agent-runtime") : null;
        var chatButton = chatRuntime && chatRuntime.shadowRoot ? chatRuntime.shadowRoot.querySelector('button[part="activator"]') : null;
        if (!chatButton && chatRoot) chatButton = chatRoot.querySelector('button[part="activator"]');
        if (!chatButton) return;

        var chatRect = chatButton.getBoundingClientRect();
        if (!chatRect.width || !chatRect.height) return;

        // Inbox normally sits 20px from the viewport bottom. Any extra distance is shared with the back-to-top button.
        var chatBottom = window.innerHeight - chatRect.bottom + getTranslateY(chatHost);
        var inboxOffset = Math.max(0, Math.round(chatBottom - 20));
        document.documentElement.style.setProperty("--b5-inbox-bottom-offset", inboxOffset + "px");
    }

    function updateScrollToTopButton() {
        if (!scrollToTopButton) return;

        updateInboxBottomOffset();
        var shouldShow = window.scrollY > 1000 && (!scrollToTopMedia || scrollToTopMedia.matches);
        scrollToTopButton.classList.toggle("is-visible", shouldShow);
    }

    function scheduleScrollToTopUpdate() {
        if (scrollToTopTicking) return;
        scrollToTopTicking = true;
        window.requestAnimationFrame(function () {
            updateScrollToTopButton();
            scrollToTopTicking = false;
        });
    }

    window.addEventListener("scroll", scheduleScrollToTopUpdate, { passive: true });
    window.addEventListener("resize", scheduleScrollToTopUpdate);
    if (scrollToTopMedia) {
        if (scrollToTopMedia.addEventListener) {
            scrollToTopMedia.addEventListener("change", scheduleScrollToTopUpdate);
        } else if (scrollToTopMedia.addListener) {
            scrollToTopMedia.addListener(scheduleScrollToTopUpdate);
        }
    }
    updateScrollToTopButton();
    window.setTimeout(scheduleScrollToTopUpdate, 500);
    window.setTimeout(scheduleScrollToTopUpdate, 1500);
});
